import React, { useState, useEffect } from 'react'
import {
  Card,
  Table,
  Button,
  Collapse,
  Row,
  Col,
  Tabs,
  Divider,
  message,
  Modal,
  Spin,
  Form,
  DatePicker,
  Select,
  Space,
  Avatar,
  Input,
  InputNumber,
  Tooltip,
  Tag
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import SalesHistoryPic from '../../../assets/images/sales-history.png'
import {
  RollbackOutlined,
  CheckOutlined,
  StepBackwardOutlined,
  StopOutlined,
  EditOutlined,
  MailOutlined
} from '@ant-design/icons'
import moment from 'moment'
import { userLogOut } from '../../../appRedux/actions/Auth'
import _ from 'lodash'
import { parse } from '@babel/core'
import {
  loadSaleHistoryCustomerShow,
  loadSaleHistoryCustomerLoad,
  loadSendEmailModalShow,
  loadCurrentSalesOrderData,
  loadRefundSaleStatus,
  loadIsShowReturnDialog,
  loadChildData,
  loadCurrentOrderGuidID,
  loadCustomerSearchData,
  loadSellSelectedAttributes
} from '../../../appRedux/actions/Sell'
import {
  loadPreventSellRunnerExecution,
  loadAccLaybyCreditAmount,
  loadIsInProgress,
  loadIsMainLoading
} from '../../../appRedux/actions/MainSale'
import {
  setCommonConfigs,
  loadHistoryModalCusSearch,
  loadIsSelectReg
} from '../../../appRedux/actions/CommonData'
import { SALE_HISTORY } from '../../../constants/Pages'
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  saleIsInProgress,
  setDiscCurrPerNote,
  fetchCurrentSalesOrder,
  formatDigits,
  customParse,
  StringIsNullOrEmpty,
  loadIncomingSale,
  parseFloatCustom,
  generateSaleBarcode
} from '../../../appRedux/actions/GlobalMethods'
import { calculateDiscountPercent } from '../../../appRedux/actions/ProdHelperMethods'
import CustomerModal from './CustomerModal'
import SendEmailModal from './SendEmailModal'
import InfoToPrint from '../../../components/InfoToPrint'
import SearchCustomer from '../../../components/SearchCustomer'
import ChildSaleDialog from '../../../components/ChildSaleDialog'
import MarkCompleteModal from '../../../components/SellScreen/MarkCompleteModal'
import Dummy from './dummy'
import BarcodeReader from 'react-barcode-reader'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import { GetIndexDBDataByTableName } from '../../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../../constants/IndexDBData'
import { PAYMENT_SOURCES_FOR_STORES } from '../../../constants/StoreSetting'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const Panel = Collapse.Panel
const { TabPane } = Tabs
const confirm = Modal.confirm
const { RangePicker } = DatePicker

const AllStatus = [
  {
    id: 10001,
    value: 'All Sales'
  },
  {
    id: 1,
    value: 'Lay By'
  },
  {
    id: 2,
    value: 'On Account'
  },
  {
    id: 3,
    value: 'Parked'
  },
  {
    id: 4,
    value: 'Delivery, unfulfilled'
  },
  {
    id: 5,
    value: 'Pickup, unfulfilled'
  },
  {
    id: 6,
    value: 'Completed'
  },
  {
    id: 7,
    value: 'Layby, completed'
  },
  {
    id: 8,
    value: 'On Account, completed'
  },
  {
    id: 9,
    value: 'Delivery, completed'
  },
  {
    id: 10,
    value: 'Pickup, completed'
  },
  {
    id: 11,
    value: 'Voided'
  }
]

const ProcessReturnStatus = [
  {
    id: 10002,
    value: 'All Closed Sales'
  },
  {
    id: 6,
    value: 'Completed'
  },
  {
    id: 7,
    value: 'Layby, completed'
  },
  {
    id: 8,
    value: 'On Account, completed'
  },
  {
    id: 9,
    value: 'Delivery, completed'
  },
  {
    id: 10,
    value: 'Pickup, completed'
  }
]

const ContinueSaleStatus = [
  {
    id: 10003,
    value: 'All Open Sales'
  },
  {
    id: 1,
    value: 'Lay By'
  },
  {
    id: 2,
    value: 'On Account'
  },
  {
    id: 3,
    value: 'Parked'
  }
]

const HistoryListing = ({ match }) => {
  const id = match.params.id ? match.params.id : false
  const sale = match.params.sale ? match.params.sale : false
  const history = useHistory()
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const store = useStore()

  // const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj);
  const loadDataRedux = useSelector(({ settings }) => settings.loadData)
  const getReduxStoreUsers = useSelector(({ Sell }) => Sell.getStoreUsers)
  const isFilterSaleChange = useSelector(({ Sell }) => Sell.isFilterSaleChange)
  const filterSaleID = useSelector(({ Sell }) => Sell.filterSaleID)

  const getReduxTemplatedData = useSelector(
    ({ Setup }) => Setup.receiptTemplatesData
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )

  const getReduxCustomerLoad = useSelector(
    ({ Sell }) => Sell.saleHistoryCustomerLoad
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getReduxSearhedCus = useSelector(
    ({ Sell }) => Sell.customerSearchDataForHistory
  )
  const getReduxModalSearhedCus = useSelector(
    ({ commonConfigs }) => commonConfigs.getHistoryCusSearch
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getIsInProgress = useSelector(({ MainSale }) => MainSale.isInProgress)
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const enableTaxCode = useSelector(({ MainSale }) => MainSale.enableTaxCode)

  const [getIsSpinning, setIsSpinning] = useState(true)
  const [getAllEditModalData, setAllEditModalData] = useState({})
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [visible, setVisible] = useState(false)
  const [getDetailLoading, setDetailLoading] = useState(true)
  const [getAllTableData, setAllTableData] = useState([])
  const [getDataClone, setDataClone] = useState([])
  const [getProcessReturnTableData, setProcessReturnTableData] = useState([])
  const [getContSaleTableData, setContSaleTableData] = useState([])
  const [getDetailData, setDetailData] = useState({})
  const [isDataUpdated, setIsDataUpdated] = useState(false)
  const [getPaymentList, setPaymentList] = useState([])
  const [getSaleOrderID, setSaleOrderID] = useState('')
  const [getEmailAddress, setEmailAddress] = useState('')
  const [getExpand, setExpand] = useState(false)
  const [getTabLoader, setTabLoader] = useState(false)
  const [getIsFiltered, setIsFiltered] = useState(false)
  const [getExclusiveDone, setExclusiveDone] = useState(true)
  const [getStatuses, setStatuses] = useState([])
  const [getCurrentTab, setCurrentTab] = useState('1')
  const [getModalCusID, setModalCusID] = useState('')
  //search filters states
  const [getAllStatus, setAllStatus] = useState(10001)
  const [getProcessRetStatus, setProcessRetStatus] = useState(10002)
  const [getContSaleStatus, setContSaleStatus] = useState(10003)
  const [getAllCus, setAllCus] = useState('')
  const [getProcessRetCus, setProcessRetCus] = useState('')
  const [getContSaleCus, setContSaleCus] = useState('')
  const [getAllRec, setAllRec] = useState('')
  const [getProcessRetRec, setProcessRetRec] = useState('')
  const [getContSaleRec, setContSaleRec] = useState('')
  const [getAllOut, setAllOut] = useState('All')
  const [getProcessRetOut, setProcessRetOut] = useState('All')
  const [getContSaleOut, setContSaleOut] = useState('All')
  const [getAllUser, setAllUser] = useState('All')
  const [getProcessRetUser, setProcessRetUser] = useState('All')
  const [getContSaleUser, setContSaleUser] = useState('All')
  const [getAllDate, setAllDate] = useState([])
  const [visibleModal, setVisibleModal] = useState(false)
  const [getProcessRetDate, setProcessRetDate] = useState([])
  const [getContSaleDate, setContSaleDate] = useState([])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getAccountSalePerm, setAccountSalePerm] = useState(false)
  const [getLaySalePerm, setLaySalePerm] = useState(false)
  const [getReturnExchangeAllow, setReturnExchangeAllow] = useState(false)
  const [getVoidAllow, setVoidAllow] = useState(false)
  const [getEditAllow, setEditAllow] = useState(false)

  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getRegName, setRegName] = useState('')
  const [getOutletName, setOutletName] = useState('')
  const [selOutletID, setSelOutletID] = useState('')
  const [selRegID, setSelRegID] = useState('')
  const [getOutRegData, setOutRegData] = React.useState([])
  const [getRegData, setRegData] = React.useState([])
  const [outRegLoader, setOutRegLoader] = useState(false)
  const [getOutletDisabled, setOutletDisabled] = useState(false)

  const [getPrintReceipt, setPrintReceipt] = useState(false)
  const [getPrintNoteReceipt, setPrintNoteReceipt] = useState(false)
  const [getShowDiscounts, setShowDiscounts] = useState(false)
  const [getSelectNextUser, setSelectNextUser] = useState(false)
  const [editPayList, setEditPayList] = useState([])

  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true,
    mode: 1
    // IsCurrent: true,
  })
  const [onSearchBody, setOnSearchBody] = React.useState({})

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'sell.salehistory.help')
    }

    getRepOutletsRegistersService()
    dispatch(setCommonConfigs(SALE_HISTORY))
    setStatuses(AllStatus)
    form.setFieldsValue({ Status: getAllStatus })
    getPaymentTypes()
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData ? currencyData : getCurrData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    // setIsSpinning(true);
    if (id && getExclusiveDone) {
      let body = {
        StatusID: AllStatus.filter(a => a.value == 'All Sales')[0].id,
        CustomerID: sale ? '' : id,
        ReceiptOrNote: '',
        OutletID: '',
        RegID: '',
        UserID: '',
        FromSearchDate: '',
        ToSearchDate: '',
        CurrentPageNo: 1,
        PageSize: 10,
        OrderID: sale ? id.substring(0, id.indexOf('&')) : '',
        mode: parseInt(getCurrentTab)
      }
      setExclusiveDone(false) // so that when data updated this check should go to else condition
      getFilteredSales(body)
    } else {
      if (!window.location.hash.includes('#cus') && isDataUpdated) {
        listUpdate()
        setIsDataUpdated(false)
        // getFilteredSales({ // getListingService
        //   CurrentPageNo: 1,
        //   PageSize: 10,
        //   showSizeChanger: true,
        //   mode: 1,
        //   OutletID: selOutletID ? `${selOutletID}&&_9efa-1ea9-4faf-88ed-a48e65b46643` : "",
        //   RegID: selRegID ? `${selRegID}&&_9efa-1ea9-4faf-88ed-a48e65b46643` : "",
        // });
      }
    }
  }, [isDataUpdated])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (selOutletID || selRegID) {
        getFilteredSales({
          // getListingService
          CurrentPageNo: 1,
          PageSize: 10,
          showSizeChanger: true,
          mode: 1,
          OutletID:
            selOutletID && selOutletID != 'zz'
              ? `${selOutletID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
              : '',
          RegID:
            selRegID && selRegID != 'zz'
              ? `${selRegID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
              : ''
        })
      }
    }
    return () => (mounted = false)
  }, [selOutletID, selRegID])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getModalCusID || window.location.hash.includes('#cus')) {
        let checkCusURI = window.location.hash.split('#cus')
        if (checkCusURI.length > 0) {
          window.history.replaceState(
            {},
            document.title,
            '/' + window.location.host + window.location.pathname
          )
        }
        setIsSpinning(true)
        let body = {
          CustomerID: checkCusURI.length > 0 ? checkCusURI[1] : getModalCusID,
          CurrentPageNo: 1,
          PageSize: 10
        }
        getFilteredSales(body)
        const ddata =
          getCurrentTab == '1'
            ? getAllTableData
            : getCurrentTab == '2'
            ? getProcessReturnTableData
            : getCurrentTab == '3'
            ? getContSaleTableData
            : []
        if (ddata && ddata.length > 0) {
          const data = ddata.filter(a => a.sCustomerID == getModalCusID)
          const cusName =
            data.length > 0 ? data[0].firstName + ' ' + data[0].lastName : ''
          form.setFieldsValue({ Customer: cusName })
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxCustomerLoad]) // from modal customer search

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outlet = false
      let reg = false
      if (getReduxSelectedStoreOutlets.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        setOutletName(
          getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : ''
        )
        outlet = getReduxSelectedStoreOutlets.id
        setSelOutletID(getDecryptID(outlet))
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          setSelectedOutlet(
            getReduxSelectedStoreOutlets.id
              ? getReduxSelectedStoreOutlets.id
              : selectedLocalOut.id
          )
          setOutletName(
            selectedLocalOut && selectedLocalOut.outlet
              ? selectedLocalOut.outlet
              : ''
          )
          outlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
          setSelOutletID(getDecryptID(outlet))
        } else {
          setSelOutletID('zz')
          setOutletName('')
        }
      }

      if (getReduxSelectedOutletReg.id) {
        setRegName(
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : ''
        )
        reg =
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : ''
        setSelRegID(getDecryptID(reg))

        setPrintNoteReceipt(
          getReduxSelectedOutletReg.printNoteOnReceipt ? true : false
        )
        setPrintReceipt(getReduxSelectedOutletReg.printReceipt ? true : false)
        setSelectNextUser(
          getReduxSelectedOutletReg.selectUserForNextSale ? true : false
        )
        setShowDiscounts(
          getReduxSelectedOutletReg.showDiscountsOnReceipts ? true : false
        )
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          setRegName(
            getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : selectedReg.register
          )
          reg = getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : selectedReg.id
          setSelRegID(getDecryptID(reg))

          setPrintNoteReceipt(
            getReduxSelectedOutletReg.printNoteOnReceipt ||
              selectedReg.printNoteOnReceipt
              ? true
              : false
          )
          setPrintReceipt(
            getReduxSelectedOutletReg.printReceipt || selectedReg.printReceipt
              ? true
              : false
          )
          setSelectNextUser(
            getReduxSelectedOutletReg.selectUserForNextSale ||
              selectedReg.selectUserForNextSale
              ? true
              : false
          )
          setShowDiscounts(
            getReduxSelectedOutletReg.showDiscountsOnReceipts ||
              selectedReg.showDiscountsOnReceipts
              ? true
              : false
          )
        } else {
          setRegName('')
          setSelRegID('zz')

          setPrintNoteReceipt(false)
          setPrintReceipt(false)
          setSelectNextUser(false)
          setShowDiscounts(false)
        }
      }

      if (!outlet || !reg) {
        dispatch(loadIsSelectReg(true))
      }
      if (outlet) {
        form.setFieldsValue({ Outlet: getDecryptID(outlet) })
      }
      if (reg) {
        form.setFieldsValue({ Register: getDecryptID(reg) })
      }

      return () => (mounted = false)
      // //;
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (filterSaleID && filterSaleID.includes('&')) {
        let body = {
          StatusID: 10001,
          CustomerID: '',
          ReceiptOrNote: '',
          OutletID: '',
          UserID: '',
          FromSearchDate: '',
          ToSearchDate: '',
          CurrentPageNo: 1,
          PageSize: 10,
          OrderID: filterSaleID.substring(0, filterSaleID.indexOf('&'))
        }
        getFilteredSales(body)
      }

      return () => (mounted = false)
    }
  }, [isFilterSaleChange])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
    //permissions
    if (rpData.laybySale) {
      setLaySalePerm(true)
    } else {
      setLaySalePerm(false)
    }
    if (rpData.accountSale) {
      setAccountSalePerm(true)
    } else {
      setAccountSalePerm(false)
    }
    if (rpData.returnAndExchange) {
      setReturnExchangeAllow(true)
    } else {
      setReturnExchangeAllow(false)
    }
    if (rpData.voidAllow) {
      setVoidAllow(true)
    } else {
      setVoidAllow(false)
    }
    if (rpData.editAllow) {
      setEditAllow(true)
    } else {
      setEditAllow(false)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
    setLaySalePerm(false)
    setAccountSalePerm(false)
    setReturnExchangeAllow(false)
    setVoidAllow(false)
    setEditAllow(false)
  }

  async function getPaymentTypes (body) {
    const getPayment = ds.getPaymentTypeList(body, BEHAVIOUR_TYPE.GET)
    await getPayment
      .then(res => {
        if (res && res.length > 0) {
          let body = res.map(e => {
            return {
              paymentTypeName: e.paymentTypeName ? e.paymentTypeName : '',
              paymentTypeId:
                e.paymentTypeSId && e.paymentTypeSId.includes('&')
                  ? parseInt(
                      e.paymentTypeSId.substring(
                        0,
                        e.paymentTypeSId.indexOf('&')
                      )
                    )
                  : 0
            }
          })
          setPaymentList(body)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        // setIsSpinning(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  async function getListingService (body) {
    const geListin = ds.getHistoryListingService(body, BEHAVIOUR_TYPE.GET)
    await geListin
      .then(res => {
        setIsFiltered(false)
        setTabLoader(false)
        setIsSpinning(false)
        if (res && res.length > 0) {
          // const processReturn = res.filter((elem) =>
          //   ProcessReturnStatus.find(
          //     ({ id }) =>
          //       elem.sSalesOrderStatusID.substring(
          //         "0",
          //         elem.sSalesOrderStatusID.indexOf("&")
          //       ) == id
          //   )
          // );
          // const contSale = res.filter((elem) =>
          //   ContinueSaleStatus.find(
          //     ({ id }) =>
          //       elem.sSalesOrderStatusID.substring(
          //         "0",
          //         elem.sSalesOrderStatusID.indexOf("&")
          //       ) == id
          //   )
          // );
          // setAllTableData(res);
          // setDataClone(res);
          // setProcessReturnTableData(processReturn);
          // setContSaleTableData(contSale);
          const paginationobj = {
            CurrentPageNo: res[0].currentPageNo,
            // PageSize: res[0].pageSize,
            total: res[0].totalRecords,
            showSizeChanger: true
          }
          setPagination(paginationobj)
          setDataClone(res)
          if (body.mode && body.mode == 1) {
            setAllTableData(res)
          } else if (body.mode && body.mode == 2) {
            setProcessReturnTableData(res)
          } else if (body.mode && body.mode == 3) {
            setContSaleTableData(res)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
        setTabLoader(false)
      })
  }

  async function getDetailService (body) {
    const geDetail = ds.getHistoryDetailsService(body, BEHAVIOUR_TYPE.GET)
    await geDetail
      .then(res => {
        setDetailLoading(false)
        if (res && res.data) {
          let dataInArray = []
          dataInArray.push(res.data)
          let data = dataInArray.map(e => {
            const notAllowPermission = checkCurrAndIncomingOutlet(e)
            let isContDisable = false
            if (!notAllowPermission) {
              if (
                getDecryptID(e.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('LayBy'))
              ) {
                if (!getLaySalePerm) {
                  isContDisable = true
                }
              } else if (
                getDecryptID(e.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('On Account'))
              ) {
                if (!getAccountSalePerm) {
                  isContDisable = true
                }
              }
            }
            // let isContDisable = checkCurrAndIncomingOutlet(e);
            // if (isContDisable) {
            //   if (
            //     getDecryptID(e.sSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder("LayBy"))
            //   ) {
            //     if (!getLaySalePerm) {
            //       isContDisable = false;
            //       notAllowPermission = true;
            //     }
            //   } else if (
            //     getDecryptID(e.sSalesOrderStatusID) ==
            //     getDecryptID(fetchCurrentSalesOrder("On Account"))
            //   ) {
            //     if (!getAccountSalePerm) {
            //       isContDisable = false;
            //       notAllowPermission = true;
            //     }
            //   }
            // }
            const isRepeat = true
            let totalItems = 0
            const saleTotalPrice = e.totalPrice + e.totalTax
            const toPay =
              getDecryptID(e.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
              getDecryptID(e.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('On Account'))
                ? saleTotalPrice
                : '0.00'
            let saleDisc = 0
            e.discountPercentage &&
              e.discountPercentage > 0 &&
              e.products.map(ee => {
                if (e.isRefund) {
                  let allowed = false
                  if (e.isAccountRefund) {
                    allowed = ee.isRefund && ee.isOnAccount
                  } else {
                    allowed = ee.isRefund
                  }

                  if (allowed) {
                    let disc = getIsTaxExclusive
                      ? ee.unitPrice * (e.discountPercentage / 100)
                      : ee.unitPrice * (e.discountPercentage / 100) +
                        ee.taxTotalWithoutFix * (e.discountPercentage / 100)
                    // disc = disc < 0 ? disc * -1 : disc;
                    saleDisc += disc
                  }
                } else {
                  let allow = true
                  if (
                    getDecryptID(e.sSalesOrderStatusID) ==
                      getDecryptID(
                        fetchCurrentSalesOrder('Layby, completed')
                      ) ||
                    getDecryptID(e.sSalesOrderStatusID) ==
                      getDecryptID(
                        fetchCurrentSalesOrder('On Account, completed')
                      )
                  ) {
                    allow = ee.isOnAccount ? true : false
                  }
                  if (allow) {
                    saleDisc += getIsTaxExclusive
                      ? ee.unitPrice * (e.discountPercentage / 100)
                      : ee.unitPrice * (e.discountPercentage / 100) +
                        ee.taxTotalWithoutFix * (e.discountPercentage / 100)
                  }
                }
              })
            let totalPay = 0
            dataInArray &&
              dataInArray[0] &&
              dataInArray[0].payments.map(x => {
                totalPay += parseFloat(x.amount)
              })
            return {
              isRepeat: isRepeat,
              isRefundSale: e.isRefund,
              behaviorName: e.behaviorName,
              e_SalesOrderID: e.e_SalesOrderID,
              receipt: e.receiptCode,
              // receipt: e.receiptNo,
              // receipt: e.receipt,
              key: e.key,
              e_SalesOrderStatusID: e.e_SalesOrderStatusID,
              sSalesOrderStatusID: e.sSalesOrderStatusID,
              e_OutletID: e.e_OutletID,
              sOutletID: e.sOutletID,
              registerID: e.registerID,
              e_RegisterID: e.e_RegisterID,
              sRegisterID: e.sRegisterID,
              e_CustomerID: e.e_CustomerID,
              sCustomerID: e.sCustomerID,
              sCustomerGroupId: e.sCustomerGroupId,
              sCreatedBy: e.sCreatedBy,
              sUpdatedBy: e.sUpdatedBy,
              e_ParentSalesOrderID: e.e_ParentSalesOrderID,
              sParentSalesOrderID: e.sParentSalesOrderID,
              notes: e.notes,
              status: e.status,
              customerGroupName: e.customerGroupName,
              firstName: e.firstName,
              lastName: e.lastName,
              customerEmail: e.customerEmail,
              customerCode: e.customerCode,
              customerPhone: e.customerPhone,
              customerAddress: e.customerAddress,
              soldBy: e.soldBy,
              outletName: e.outletName,
              storeName: e.storeName,
              registerName: e.registerName,
              totalSavings: e.totalSavings,
              toPay: toPay,
              totalPrice: saleTotalPrice
                ? formatDigits(saleTotalPrice, getDecimalPlaces)
                : '0.00',
              totalTax: e.totalTax
                ? formatDigits(e.totalTax, getDecimalPlaces)
                : '0.00',
              balance: e.balance
                ? formatDigits(e.balance, getDecimalPlaces)
                : '0.00',
              toPay: e.balance
                ? formatDigits(e.balance, getDecimalPlaces)
                : '0.00',
              // salesOrderDiscountPrice: e.salesOrderDiscountPrice
              //   ? customParse(e.salesOrderDiscountPrice).toFixed(
              //     getDecimalPlaces
              //   )
              //   : "0.00",
              // additionalDiscount: e.salesOrderDiscountPrice
              //   ? customParse(e.salesOrderDiscountPrice).toFixed(
              //     getDecimalPlaces
              //   )
              //   : "",saleDisc
              salesOrderDiscountPrice: saleDisc
                ? formatDigits(saleDisc, getDecimalPlaces)
                : '0.00',
              additionalDiscount: saleDisc
                ? formatDigits(saleDisc, getDecimalPlaces)
                : '',
              discountPercentage: e.discountPercentage
                ? formatDigits(e.discountPercentage, getDecimalPlaces)
                : '0.00',
              discountIsPercentage: e.discountIsPercentage,
              monitoringComment: e.monitoringComment,
              sellDate: e.sellDate,
              products:
                e.products && e.products.length > 0
                  ? e.products.map(r => {
                      let price = r.totalPrice
                        ? formatDigits(r.totalPrice, getDecimalPlaces)
                        : '0.00'
                      if (getIsTaxExclusive) {
                        price = r.unitPrice
                          ? formatDigits(r.unitPrice, getDecimalPlaces)
                          : '0.00'
                      }
                      const dispQuanity = r.displayQuantity
                        ? r.displayQuantity
                        : r.quantity
                      totalItems += dispQuanity
                      let totalIncPrice = r.totalPrice
                      let totalExcPrice = r.unitPrice
                      let exclusiUnitPrice = r.unitPrice / dispQuanity
                      let inclusiUnitPrice = r.totalPrice / dispQuanity
                      const saleItemDisc = r.salesItemDiscount / dispQuanity

                      let tax = 0
                      let taxCode = ''
                      e.taxes &&
                        e.taxes.length > 0 &&
                        e.taxes
                          .filter(
                            a =>
                              `${a.itemIdentifyID}` ==
                              getDecryptID(r.sSalesOrderItemID)
                          )
                          .map(cc => {
                            if (cc.taxCode) {
                              taxCode += `${
                                taxCode ? `, ${cc.taxCode}` : `${cc.taxCode}`
                              }`
                            }
                            if (!cc.isFix) {
                              tax += cc.taxValue
                            }
                          })

                      // const tax =
                      //   e.taxes &&
                      //     e.taxes.length > 0 &&
                      //     e.taxes.filter(
                      //       (a) =>
                      //         `${a.itemIdentifyID}` ==
                      //         getDecryptID(r.sSalesOrderItemID)
                      //     ).length > 0
                      //     ? e.taxes.filter(
                      //       (a) =>
                      //         `${a.itemIdentifyID}` ==
                      //         getDecryptID(r.sSalesOrderItemID)
                      //     )[0].taxValue
                      //     : 0;
                      const basePPrice = r.basePrice
                        ? customParse(r.basePrice)
                        : 0
                      const promoValue =
                        r.promotions &&
                        r.promotions.length > 0 &&
                        r.promotions[0].promotionValue
                          ? customParse(
                              r.promotions[0].promotionValue / r.quantity
                            )
                          : 0
                      const promoPercent = calculateDiscountPercent(
                        getIsTaxExclusive,
                        basePPrice,
                        tax ? customParse(tax / 100) : 0,
                        promoValue
                      )
                      const pbPercent = calculateDiscountPercent(
                        getIsTaxExclusive,
                        basePPrice,
                        tax ? customParse(tax / 100) : 0,
                        r.priceBookValue
                          ? customParse(r.priceBookValue / r.quantity)
                          : 0
                      )
                      return {
                        e_SalesOrderID: r.e_SalesOrderID,
                        sSalesOrderID: r.sSalesOrderID,
                        e_SalesOrderItemID: r.e_SalesOrderItemID,
                        sSalesOrderItemID: r.sSalesOrderItemID,
                        itemIdentifyID: r.itemIdentifyID,
                        e_ProductID: r.e_ProductID,
                        sProductID: r.sProductID,
                        isRemoveProduct: r.isRemoveProduct,
                        productName: r.productName,
                        quantity: r.quantity
                          ? formatDigits(r.quantity, getDecimalPlaces)
                          : '0.00',
                        unitPrice: r.unitPrice
                          ? formatDigits(r.unitPrice, getDecimalPlaces)
                          : '0.00',
                        salesItemDiscount: saleItemDisc
                          ? formatDigits(saleItemDisc, getDecimalPlaces)
                          : '0.00',
                        discountPercentage: r.discountPercentage
                          ? formatDigits(r.discountPercentage, getDecimalPlaces)
                          : '0.00',
                        discountIsPercentage: r.discountIsPercentage,
                        totalTax: r.totalTax
                          ? formatDigits(r.totalTax, getDecimalPlaces)
                          : '0.00',
                        totalPrice: r.totalPrice
                          ? formatDigits(r.totalPrice, getDecimalPlaces)
                          : '0.00',
                        displayPrice: r.displayPrice
                          ? formatDigits(r.displayPrice, getDecimalPlaces)
                          : '0.00',
                        displayQuantity: r.displayQuantity,
                        variantName: r.variantName,
                        basePrice: basePPrice,
                        baseTax: r.baseTax
                          ? formatDigits(r.baseTax, getDecimalPlaces)
                          : '0.00',
                        loyaltyValue: r.loyaltyValue
                          ? formatDigits(r.loyaltyValue, getDecimalPlaces)
                          : '0.00',
                        isPriceAdjusted: r.isPriceAdjusted,
                        productNote: r.productNote,
                        markupPercentage: r.markupPercentage
                          ? formatDigits(r.markupPercentage, getDecimalPlaces)
                          : '0.00',
                        exclusiveUnitPrice: exclusiUnitPrice
                          ? formatDigits(exclusiUnitPrice, getDecimalPlaces)
                          : '0.00',
                        inclusiveUnitPrice: inclusiUnitPrice
                          ? formatDigits(inclusiUnitPrice, getDecimalPlaces)
                          : '0.00',
                        totalExcPrice: totalExcPrice
                          ? formatDigits(totalExcPrice, getDecimalPlaces)
                          : '0.00',
                        totalIncPrice: totalIncPrice
                          ? formatDigits(totalIncPrice, getDecimalPlaces)
                          : '0.00',
                        monitoringComment: r.monitoringComment,
                        e_Tax_id: r.e_Tax_id,
                        promotions:
                          r.promotions && r.promotions.length > 0
                            ? r.promotions[0]
                            : {},
                        totalPriceReceipt: price,
                        priceBookValue: r.priceBookValue
                          ? formatDigits(r.priceBookValue, getDecimalPlaces)
                          : '0.00',
                        priceBookPercent: pbPercent
                          ? formatDigits(pbPercent, getDecimalPlaces)
                          : '0.00',
                        promotionPercent: promoPercent
                          ? formatDigits(promoPercent, getDecimalPlaces)
                          : '0.00',
                        taxCode: enableTaxCode ? taxCode : '',
                        userID: r.userID,
                        userName: r.userName
                      }
                    })
                  : [],
              totalRecords: e.totalRecords,
              currentPageNo: e.currentPageNo,
              payments:
                e.payments && e.payments.length > 0
                  ? e.payments.map(f => {
                      return {
                        sSalesOrderID: f.sSalesOrderID,
                        sSalesOrderPaymentID: f.sSalesOrderPaymentID,
                        e_PaymentTypeID: f.e_PaymentTypeID,
                        e_SalesOrderPaymentID: f.e_SalesOrderPaymentID,
                        sPaymentTypeID: f.sPaymentTypeID,
                        paymentName: f.paymentName,
                        paymentDate: f.paymentDate,
                        paymentOnDisplay: f.paymentOn,
                        paymentOn: f.paymentOnShort
                          ? f.paymentOnShort
                          : f.paymentOn
                          ? f.paymentOn
                          : '',
                        amount: f.amount
                          ? formatDigits(f.amount, getDecimalPlaces)
                          : '0.00',
                        paymentTypeSourceId: f.paymentTypeSourceId
                      }
                    })
                  : [],
              taxes:
                e.taxes && e.taxes.length > 0
                  ? e.taxes.map(w => {
                      return {
                        sSalesOrderID: w.sSalesOrderID,
                        sSalesOrderItemID: w.sSalesOrderItemID,
                        itemIdentifyID: w.itemIdentifyID,
                        sSalesOrderItemTaxID: w.sSalesOrderItemTaxID,
                        sTaxID: w.sTaxID,
                        taxPrice: w.taxPrice
                          ? formatDigits(w.taxPrice, getDecimalPlaces)
                          : '0.00',
                        saleTaxName: w.saleTaxName ? w.saleTaxName : '',
                        taxValue: w.taxValue
                          ? formatDigits(w.taxValue, getDecimalPlaces)
                          : '0.00',
                        baseTaxValue: w.baseTaxValue
                          ? formatDigits(w.baseTaxValue, getDecimalPlaces)
                          : '0.00'
                      }
                    })
                  : [],
              // taxesSum:
              //   e.taxesSum && e.taxesSum.length > 0
              //     ? e.taxesSum.map((wx) => {
              //       let taxModPrice = wx.taxPrice;
              //       if (e.discountIsPercentage && e.discountPercentage) {
              //         taxModPrice -=
              //           taxModPrice * (e.discountPercentage / 100);
              //       }
              //       return {
              //         sSalesOrderID: wx.sSalesOrderID,
              //         sTaxID: wx.sTaxID,
              //         taxPrice: taxModPrice
              //           ? formatDigits(taxModPrice, getDecimalPlaces)
              //           : "0.00",
              //         saleTaxName: wx.saleTaxName ? wx.saleTaxName : "",
              //         taxValue: wx.taxValue
              //           ? formatDigits(wx.taxValue, getDecimalPlaces)
              //           : "0.00",
              //       };
              //     })
              //     : [],
              taxesSum:
                e.taxesSum && e.taxesSum.length > 0
                  ? e.taxesSum.map(wx => {
                      let taxModPrice = wx.taxPrice
                      if (!wx.isFix) {
                        if (e.isRefund) {
                          // yahan per diff cond honi chahye
                          // taxModPrice *= -1;
                          if (
                            (e.discountIsPercentage && e.discountPercentage) ||
                            e.salesOrderDiscountPrice
                          ) {
                            taxModPrice -=
                              taxModPrice * (e.discountPercentage / 100)
                          }
                        } else {
                          if (
                            (e.discountIsPercentage && e.discountPercentage) ||
                            e.salesOrderDiscountPrice
                          ) {
                            taxModPrice -=
                              taxModPrice * (e.discountPercentage / 100)
                          }
                        }
                      }
                      return {
                        sSalesOrderID: wx.sSalesOrderID,
                        sTaxID: wx.sTaxID,
                        taxPrice: taxModPrice
                          ? formatDigits(taxModPrice, getDecimalPlaces)
                          : '0.00',
                        saleTaxName: wx.saleTaxName ? wx.saleTaxName : '',
                        taxValue: wx.taxValue
                          ? formatDigits(wx.taxValue, getDecimalPlaces)
                          : '0.00',
                        isFix: wx.isFix ? wx.isFix : false,
                        fixRate: wx.taxValue
                          ? formatDigits(wx.taxValue, getDecimalPlaces)
                          : '0.00',
                        taxCode: enableTaxCode && wx.taxCode ? wx.taxCode : ''
                      }
                    })
                  : [],
              totalItems: totalItems,
              isContDisable: isContDisable,
              notAllowPermission: notAllowPermission,
              childs: e.childs && e.childs.length > 0 ? e.childs : [],
              totalLoyaltyValue: e.totalLoyaltyValue ? e.totalLoyaltyValue : 0,
              saleid: e.key ? getDecryptID(e.key) : 0,
              change: e.change ? formatDigits(e.change, getDecimalPlaces) : 0,
              sellSelData:
                e.sellAttributes && e.sellAttributes.length > 0
                  ? e.sellAttributes
                  : [],
              Notes: e.notes,
              extraPrinters: e.extraPrinters ? e.extraPrinters : false,
              isOffline: e.isOffline,
              indexKey: e.indexKey,
              barcode: generateSaleBarcode(
                getDecryptID(localStorage.getItem('storeReqNo')),
                e && e.sOutletID ? getDecryptID(e.sOutletID) : false,
                e && e.sRegisterID ? getDecryptID(e.sRegisterID) : false,
                e.key ? getDecryptID(e.key) : e.indexKey
              ),
              saleNature:
                getDecryptID(e.sSalesOrderStatusID) == '1'
                  ? 'Sale on Layby'
                  : getDecryptID(e.sSalesOrderStatusID) == '2'
                  ? 'Sale on Account'
                  : ''
              // change : totalPay  && saleTotalPrice ? totalPay > saleTotalPrice ? formatDigits(totalPay - saleTotalPrice,getDecimalPlaces)  : 0 : 0,
            }
          })
          setDetailData(data && data.length > 0 ? data[0] : {})

          // for edit payments
          const pays = []
          if (res.data.payments && res.data.payments.length > 0) {
            const filPay = res.data.payments.filter(
              rr => rr.paymentTypeSourceId == PAYMENT_SOURCES_FOR_STORES.cash
            )
            filPay &&
              filPay.length > 0 &&
              res.data.payments.map(f => {
                const data = {
                  sSalesOrderID: f.sSalesOrderID,
                  sSalesOrderPaymentID: f.sSalesOrderPaymentID,
                  e_PaymentTypeID: f.e_PaymentTypeID,
                  e_SalesOrderPaymentID: f.e_SalesOrderPaymentID,
                  sPaymentTypeID: f.sPaymentTypeID,
                  paymentName: f.paymentName,
                  paymentDate: f.paymentDate,
                  paymentOnDisplay: f.paymentOn,
                  paymentOn: f.paymentOnShort
                    ? f.paymentOnShort
                    : f.paymentOn
                    ? f.paymentOn
                    : '',
                  amount: f.amount
                    ? formatDigits(f.amount, getDecimalPlaces)
                    : '0.00',
                  paymentTypeSourceId: f.paymentTypeSourceId
                }
                pays.push(data)
              })
          }
          if (pays && pays.length > 0) setEditPayList(pays)
          else setEditPayList([])
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setDetailLoading(false)
      })
  }

  async function postVoidSale (body) {
    const postVoid = ds.postVoidSaleService(body, BEHAVIOUR_TYPE.UPDATE)
    await postVoid
      .then(res => {
        setIsSpinning(false)
        if (res && res.msg.includes('Voided')) {
          message.success('Successfully Voided Sale')
          setTimeout(() => {
            listUpdate()
            // setIsDataUpdated(!isDataUpdated)
          }, 1000)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }

  async function postEditSale (body) {
    const postEdit = ds.postEditSaleService(body, BEHAVIOUR_TYPE.UPDATE)
    await postEdit
      .then(res => {
        setIsSpinning(false)
        if (res.includes('Saved')) {
          message.success('Successfully Updated Sale')
          setTimeout(() => {
            listUpdate()
            // setIsDataUpdated(!isDataUpdated)
          }, 1000)
        } else if (res.includes('required')) {
          message.warn('Information Required')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  async function getRepOutletsRegistersService () {
    setOutRegLoader(true)
    await ds
      .getRepOutRegs({}, BEHAVIOUR_TYPE.GET)
      .then(qw => {
        setOutRegLoader(false)
        if (qw && qw.length > 0) {
          const reg = [{ registerID: 'xxx', registerName: 'All Registers' }]
          qw.map(ee => {
            ee.registers &&
              ee.registers.length > 0 &&
              ee.registers.map(ff => {
                reg.push(ff)
              })
          })
          setRegData(reg && reg.length > 0 ? reg : [])
          qw.splice(0, 0, { outletID: 'xxx', outletName: 'All Outlet' })
          setOutRegData(qw)
        }
      })
      .catch(e => {
        setOutRegLoader(false)
        notAllowMsgCheck(e)
      })
  }

  async function getFilteredSales (body) {
    setIsSpinning(true)
    const getFiltered = ds.getFilteredSalesService(body, BEHAVIOUR_TYPE.GET)
    await getFiltered
      .then(res => {
        setOnSearchBody(body)
        setIsFiltered(true)
        setTabLoader(false)
        setIsSpinning(false)
        dispatch(loadSaleHistoryCustomerShow(false))
        let paginationobj = {
          CurrentPageNo: 1,
          PageSize: 0,
          total: 0,
          showSizeChanger: false
        }
        if (res && res.length > 0) {
          paginationobj.CurrentPageNo = res[0].currentPageNo
          paginationobj.PageSize = res[0].pageSize
          paginationobj.total = res[0].totalRecords
          paginationobj.showSizeChanger = true
          setDataClone(res)
          res.sort((a, b) => (a.receipt < b.receipt ? 1 : -1))
        }
        setPagination(paginationobj)
        if (body.mode == '1') {
          setAllTableData(res)
        } else if (body.mode == '2') {
          setProcessReturnTableData(res)
        } else if (body.mode == '3') {
          setContSaleTableData(res)
        }
      })
      .catch(e => {
        setIsSpinning(false)
        setTabLoader(false)
        dispatch(loadSaleHistoryCustomerShow(false))
      })
  }

  function checkCurrAndIncomingOutlet (e) {
    let res = false
    if (
      getDecryptID(e.sSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
      getDecryptID(e.sSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('On Account'))
    ) {
      if (getDecryptID(getSelectedOutlet) !== getDecryptID(e.sOutletID)) {
        res = true
      }
    }
    return res
  }

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  const colomns = [
    {
      title: <IntlMessages id='sell.salehistory.col1' />,
      dataIndex: 'receipt',
      key: 'receipt',
      render: (text, record) => {
        return (
          <>
            <Row>
              <div className='ReceiptNO'>
                {record.receiptCode}
                {/* {record.receiptNo} */}
              </div>
              {/* <div style={{ fontSize: 9, display: "contents" }}>
                {record.key ? ` (Ref No: ${getDecryptID(record.key)})` : ""}
              </div> */}
            </Row>
            <Row className='ReceiptDate'>
              {record.sellDate
                ? moment(record.sellDate).format('YYYY-MM-DD HH:mm a')
                : ''}
            </Row>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col2' />,
      dataIndex: 'customerGroupName',
      key: 'customerGroupName',
      render: (text, record, key) => {
        const isEvenOrOdd = evenOrOdd(key)
        let firstLetter = record.firstName ? record.firstName.charAt(0) : 'x'
        let secondLetter = record.lastName ? record.lastName.charAt(0) : 'y'
        // let name = [];
        // const xyz = record.firstName ? record.firstName + " " + record.lastName : "";
        // name = xyz.split(" ").length > 1 ? xyz.split(" ") : name.push(xyz);
        const lettersName =
          firstLetter.toUpperCase() + secondLetter.toUpperCase()
        return (
          record.sCustomerID != '' && (
            <div className='gx-module-list-icon'>
              <Row gutter={6}>
                <Col>
                  <div className='gx'>
                    <Avatar
                      style={{ fontWeight: 'bold' }}
                      className={`gx-avatar gx-bg-${
                        isEvenOrOdd == 'even' ? 'green' : 'blue'
                      } gx-size-18 mr-10`}
                    >
                      {lettersName}
                    </Avatar>
                  </div>
                </Col>

                <Col>
                  <div className='gx-module-list-content'>
                    <div className='gx-mail-user-des'>
                      <span
                        onClick={() => {
                          let randomNbr = Math.floor(
                            Math.random() * (999 - 100 + 1) + 100
                          )
                          let idCus = record.sCustomerID + randomNbr.toString()
                          setModalCusID(idCus)
                          dispatch(loadSaleHistoryCustomerShow(true))
                        }}
                        className='gx-sender-name'
                        style={{ fontSize: 12, cursor: 'pointer' }}
                      >
                        {/* {name.map((ae, i) => {
                          return (
                            <p key={i} className="custom-customer-name">
                              {ae}
                            </p>
                          )
                        })} */}
                        {`${record.firstName} ${record.lastName}`}
                      </span>

                      <span className='gx-toolbar-separator'>&nbsp;</span>

                      <span
                        style={{ fontSize: 8 }}
                        className='vd-flag sm:hidden'
                      >
                        {text ? text : 'All Customers'}
                      </span>
                    </div>
                    <div style={{ fontSize: 9 }} className='gx-message'>
                      <p className='gx-text-truncate'>
                        {record.customerCode ? record.customerCode : '123-ABC'}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )
        )
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col3' />,
      dataIndex: 'soldBy',
      key: 'soldBy',
      render: (text, record) => {
        return (
          <>
            <span className='gx-link' style={{ fontWeight: '500' }}>
              {text}
            </span>
            <p>
              {record.outletName ? record.outletName : ''}
              <br />
              {record.registerName ? record.registerName : ''}
            </p>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col4' />,
      dataIndex: 'notes',
      key: 'notes',
      render: text => {
        return <span>{text}</span>
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col5' />,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      render: (text, record) => {
        let price = text + record.totalTax
        price = price ? formatDigits(price, getDecimalPlaces) : '0.00'
        return (
          <span style={{ fontWeight: '500' }}>
            {getCurrData.currencyCode ? getCurrData.currencyCode : ''} {price}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col6' />,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        let textColor = '#038fde'
        if (text.includes('ompl')) {
          textColor = 'green'
        } else if (text.includes('oid')) {
          textColor = 'red'
        } else if (text.includes('unfulfilled')) {
          textColor = '#6692b0'
        }
        return (
          <span
            style={{
              fontWeight: '500',
              color: textColor
            }}
          >
            {text.includes('oid') &&
            record.sParentSalesOrderID &&
            record.sParentSalesOrderID != ''
              ? `${text}, Return`
              : text}
          </span>
        )
      }
    }
  ]

  const ExpandedRowRenderViewAll = props => {
    const data = props.data ? props.data : {}

    function showVoidConfirm (key) {
      confirm({
        className: 'voidconfirm',
        title: 'Are you sure you want to VOID this sale?',
        content: (
          <span>
            {
              'This will return the products back into your inventory and remove any payments that were recorded. You’ll still be able to see the details of this sale once it has been voided. This can’t be undone.'
            }
          </span>
        ),
        okText: 'Void Sale',
        cancelText: "Don't Void",
        okButtonProps: { className: 'dk-btn-add' },
        cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
        onOk () {
          setIsSpinning(true)
          postVoidSale([
            {
              SalesOrderID: key
            }
          ])
        },
        onCancel () {
          //console.log('Cancel');
        }
      })
    }

    function onEditClick () {
      let data = getDetailData
      form.setFieldsValue({
        DateTime: data.sellDate ? moment(data.sellDate) : '',
        Note: data.notes ? data.notes : ''
      })
      if (editPayList && editPayList.length > 0) {
        editPayList.map((e, key) => {
          form.setFieldsValue({
            [`PaymentType${key}`]:
              e.sPaymentTypeID && e.sPaymentTypeID.includes('&')
                ? parseInt(
                    e.sPaymentTypeID.substring(0, e.sPaymentTypeID.indexOf('&'))
                  )
                : '',
            [`PaymentDateTime${key}`]:
              e.paymentDate && !e.paymentDate.includes('0001')
                ? moment(e.paymentDate)
                : '',
            [`Amount${key}`]: e.amount ? e.amount : ''
          })
        })
      }
      if (data.customerCode) {
        let firstLetter = data.firstName ? data.firstName.charAt(0) : 'x'
        let secondLetter = data.lastName ? data.lastName.charAt(0) : 'y'
        let lettersName = firstLetter.toUpperCase() + secondLetter.toUpperCase()
        let cusData = {
          key: data.sCustomerID,
          customerName: data.firstName + ' ' + data.lastName,
          customerCode: data.customerCode,
          groupName: data.customerGroupName,
          letterName: lettersName
        }
        dispatch(loadHistoryModalCusSearch(cusData))
        // setCustomerObj(cusData);
      } else {
        dispatch(loadHistoryModalCusSearch({}))
        // setCustomerObj({});
      }
      setVisible(true)
    }
    //salis
    function handleClickReturnItems (data) {
      // let getChilds = getDataClone.filter(
      //   (a) => getDecryptID(a.sParentSalesOrderID) == getDecryptID(data.key)
      // );
      let getChilds = getDetailData.childs ? getDetailData.childs : []
      if (getChilds && getChilds.length > 0) {
        getChilds[0].sParentSalesOrderID = data.key
        dispatch(loadChildData(getChilds))
        dispatch(loadIsShowReturnDialog(true))
      } else {
        dispatch(loadIsInProgress(true))
        dispatch(loadRefundSaleStatus(1))
        localStorage.setItem('orderGuidID', '')
        localStorage.setItem('parentOrderGuidID', data.key)
        history.push('/dashboard/sell/mainsale/webregister')
      }
      // let outletID = getSelectedOutlet;
      // let body = {
      //   OutletID: outletID,
      //   SalesOrderID: data.key,
      //   //SalesOrderStatusID: AllStatus.filter((a) => a.value == "completed")[0].id,
      //   CustomerID: "",
      //   UserID: "",
      //   CurrentPageNo: 1,
      //   PageSize: 10,
      //   isRefund : true
      // };
      // getSaleHistoryDetailService(body);
    }
    return (
      <>
        {data && (
          <Spin
            tip={<IntlMessages id='sell.cashlisting.cashloading' />}
            spinning={getDetailLoading}
            size='large'
          >
            {/* <Dummy
              data={getDetailData}
              templateData={
                getReduxTemplatedData && getReduxTemplatedData.length > 0
                  ? getReduxTemplatedData.filter((e) => e.isDefault == true)[0]
                  : []
              }
              currData={getCurrData}
              outletName={getOutletName}
              registerName={getRegName}
              getIsTaxExclusive={getIsTaxExclusive}
            /> */}
            <ChildSaleDialog
              curr={
                getCurrData.currencyCode
                  ? getCurrData.currencyCode
                  : getCurrData.currencySymbol
                  ? getCurrData.currencySymbol
                  : ''
              }
            />
            <MarkCompleteModal
              visible={visibleModal}
              setVisible={setVisibleModal}
              status={
                getDecryptID(data.sSalesOrderStatusID) == '4'
                  ? '9'
                  : getDecryptID(data.sSalesOrderStatusID) == '5'
                  ? '10'
                  : ''
              }
              orderid={data.key}
              setIsDataUpdated={setIsDataUpdated}
              // isDataUpdated={isDataUpdated}
            />

            <div className='sub-table-box'>
              <SendEmailModal id={getSaleOrderID} email={getEmailAddress} />

              <Row className='sub-table-box-header'>
                <Col lg={16} md={16} sm={16} xs={16}>
                  <h1 className='mb-0'>
                    {' '}
                    <IntlMessages id='sell.salehistory.bochead' />{' '}
                  </h1>

                  {getDetailData &&
                    getDetailData.sellSelData &&
                    getDetailData.sellSelData.length > 0 && (
                      <div style={{ marginTop: 2, marginBottom: 12 }}>
                        {getDetailData.sellSelData.map((as, io) => {
                          const isEvenOrOdd = evenOrOdd(io)
                          return (
                            <Tag
                              color={
                                isEvenOrOdd == 'even' ? '#2db7f5' : '#87d068'
                              }
                              key={io}
                            >
                              {as.groupName ? `${as.groupName}: ` : ''}
                              {as.attributeName ? `${as.attributeName}` : ''}
                            </Tag>
                          )
                        })}
                      </div>
                    )}
                </Col>

                <Col lg={8} md={8} sm={8} xs={8} className='text-right'>
                  {getDetailData &&
                  getDetailData.sParentSalesOrderID &&
                  getDetailData.sParentSalesOrderID.includes('&') &&
                  getDecryptID(getDetailData.sSalesOrderStatusID) !=
                    getDecryptID(fetchCurrentSalesOrder('Parked, return')) &&
                  getDetailData.sParentSalesOrderID.substring(
                    0,
                    getDetailData.sParentSalesOrderID.indexOf('&')
                  ) > 0 ? (
                    <Button
                      className='dk-btn-expand-view dk-wd-auto'
                      onClick={() => {
                        onSearchFinish({
                          OrderID: getDetailData.sParentSalesOrderID.substring(
                            0,
                            getDetailData.sParentSalesOrderID.indexOf('&')
                          )
                        })
                      }}
                    >
                      <Space size='small'>
                        <StepBackwardOutlined />
                        {<IntlMessages id='sell.salehistory.vieworignalsale' />}
                      </Space>
                    </Button>
                  ) : getDetailData &&
                    getDetailData.status &&
                    (getDetailData.sSalesOrderStatusID.substring(
                      0,
                      getDetailData.sSalesOrderStatusID.indexOf('&')
                    ) == AllStatus.filter(a => a.id == 3)[0].id ||
                      getDetailData.sSalesOrderStatusID.substring(
                        0,
                        getDetailData.sSalesOrderStatusID.indexOf('&')
                      ) == AllStatus.filter(a => a.id == 1)[0].id ||
                      getDetailData.sSalesOrderStatusID.substring(
                        0,
                        getDetailData.sSalesOrderStatusID.indexOf('&')
                      ) == AllStatus.filter(a => a.id == 2)[0].id ||
                      getDecryptID(getDetailData.sSalesOrderStatusID) ==
                        getDecryptID(
                          fetchCurrentSalesOrder('Parked, return')
                        )) ? (
                    <>
                      {getDetailData.isContDisable ||
                      getDetailData.notAllowPermission ? (
                        <Tooltip
                          placement='leftBottom'
                          title={
                            getDetailData.notAllowPermission ? (
                              <IntlMessages id='sale.history.disablecont' />
                            ) : (
                              <IntlMessages id='saleHistory.cont.notallow' />
                            )
                          }
                        >
                          <Button
                            type='primary'
                            className='custom-returnbtn disable-custom-btn'
                            size='small'
                          >
                            <Space size='small'>
                              <RollbackOutlined />
                              {<IntlMessages id='sell.salehistory.contsale' />}
                            </Space>
                          </Button>
                        </Tooltip>
                      ) : (
                        <Button
                          type='primary'
                          className='custom-returnbtn'
                          onClick={() => {
                            if (checkCurrAndIncomingOutlet(getDetailData)) {
                              const asd =
                                'This sale was created at another outlet, this must be continued there to keep your inventory correct.'
                              message.info(asd, 5)
                            } else {
                              onAccLaybyRetrve(data.key, data.indexKey)
                            }
                          }}
                          size='small'
                        >
                          <Space size='small'>
                            <RollbackOutlined />
                            {<IntlMessages id='sell.salehistory.contsale' />}
                          </Space>
                        </Button>
                      )}
                    </>
                  ) : getDetailData &&
                    getDetailData.status &&
                    getDetailData.sSalesOrderStatusID.substring(
                      0,
                      getDetailData.sSalesOrderStatusID.indexOf('&')
                    ) != '13' &&
                    getDetailData.sSalesOrderStatusID.substring(
                      0,
                      getDetailData.sSalesOrderStatusID.indexOf('&')
                    ) != '16' ? (
                    <>
                      {!getReturnExchangeAllow ? (
                        <Tooltip
                          placement='leftBottom'
                          title={
                            <IntlMessages id='saleHistory.returnexchange.notallow' />
                          }
                        >
                          <Button
                            type='primary'
                            className='custom-returnbtn disable-custom-btn'
                            size='small'
                          >
                            <Space size='small'>
                              <RollbackOutlined />
                              {<IntlMessages id='sell.salehistory.return' />}
                            </Space>
                          </Button>
                        </Tooltip>
                      ) : (
                        <Button
                          type='primary'
                          className='dk-wd-auto'
                          disabled={
                            getDetailData.status &&
                            getDetailData.status.includes('oided')
                              ? true
                              : false
                          }
                          onClick={() => handleClickReturnItems(data)}
                          size='small'
                        >
                          <Space size='small'>
                            <RollbackOutlined />
                            {<IntlMessages id='sell.salehistory.return' />}
                          </Space>
                        </Button>
                      )}
                    </>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>

              <Row className=''>
                <Col
                  xl={18}
                  lg={18}
                  md={24}
                  sm={24}
                  xs={24}
                  className='add-row-divider'
                >
                  {getDetailData.products &&
                    getDetailData.products.length > 0 &&
                    getDetailData.products.map((e, key) => {
                      return (
                        <Row className='mb-2'>
                          <Col xl={8} lg={24} md={24} sm={24} xs={24}>
                            <Row gutter={10}>
                              <Col>
                                <h4 className='mb-0'>{e.quantity}</h4>
                              </Col>
                              <Col>
                                <h4 className='mb-0'>{e.productName}</h4>
                              </Col>
                            </Row>

                            <Row>
                              <Col span={24}>
                                {e.promotions &&
                                !isEmptyObject(e.promotions) &&
                                e.promotions.promotionName &&
                                e.promotions.promotionName != '' ? (
                                  <p className='font-size-smaller'>
                                    {`Promotion: ${
                                      e.promotions.promotionName
                                    } (${
                                      e.promotionPercent
                                        ? `${e.promotionPercent}% / `
                                        : ''
                                    } ${
                                      getCurrData.currencyCode
                                        ? getCurrData.currencyCode
                                        : getCurrData.currencyCode
                                        ? getCurrData.currencySymbol
                                        : ''
                                    } ${
                                      e.promotions.promotionValue
                                        ? formatDigits(
                                            e.promotions.promotionValue /
                                              e.quantity,
                                            getDecimalPlaces
                                          )
                                        : '0.00'
                                    } off)`}
                                  </p>
                                ) : (
                                  <>
                                    {e.salesItemDiscount &&
                                      e.salesItemDiscount > 0 && (
                                        <p className='sub-txt-note'>
                                          {`"Was": ${
                                            getCurrData.currencyCode
                                          } ${formatDigits(
                                            customParse(
                                              e.totalPriceReceipt / e.quantity
                                            ) +
                                              customParse(e.salesItemDiscount),
                                            getDecimalPlaces
                                          )} 
                                              , "Disc": ${
                                                e.discountPercentage
                                              }% / ${
                                            getCurrData.currencyCode
                                          } ${e.salesItemDiscount}`}
                                        </p>
                                      )}
                                  </>
                                )}

                                {e.priceBookValue &&
                                  customParse(e.priceBookValue) > 0 && (
                                    <p className='font-size-smaller'>
                                      {`Disc: (${
                                        e.priceBookPercent
                                          ? `${e.priceBookPercent}% / `
                                          : ''
                                      } ${
                                        getCurrData.currencyCode
                                          ? getCurrData.currencyCode
                                          : getCurrData.currencySymbol
                                          ? getCurrData.currencySymbol
                                          : ''
                                      } ${e.priceBookValue} off)`}
                                    </p>
                                  )}
                                {e.productNote && e.productNote != '' && (
                                  <p className='font-size-smaller'>
                                    <IntlMessages id='sell.sell.note' />
                                    {` ${e.productNote}`}
                                  </p>
                                )}

                                {e.userName && (
                                  <p className='font-size-smaller'>
                                    {`Sold by ${e.userName}`}
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </Col>

                          <Col xl={16} lg={24} md={24} sm={24} xs={24}>
                            <Row>
                              <Col xl={8} lg={8} md={8} sm={8} xs={8}>
                                {getIsTaxExclusive ? (
                                  <>
                                    {e.exclusiveUnitPrice &&
                                      e.exclusiveUnitPrice != '0.00' && (
                                        <h4>
                                          {`@ ${getCurrData.currencyCode} ${e.exclusiveUnitPrice}`}
                                          {/* <strong>{`@ ${getCurrData.currencyCode} ${e.totalPrice}`}</strong> */}
                                        </h4>
                                      )}
                                  </>
                                ) : (
                                  <>
                                    {e.inclusiveUnitPrice &&
                                      e.inclusiveUnitPrice != '0.00' && (
                                        <h4>
                                          {`@ ${getCurrData.currencyCode} ${e.inclusiveUnitPrice}`}
                                          {/* <strong>{`@ ${getCurrData.currencyCode} ${e.totalPrice}`}</strong> */}
                                        </h4>
                                      )}
                                  </>
                                )}
                              </Col>

                              <Col xl={8} lg={8} md={8} sm={8} xs={11}>
                                <h4>
                                  {getIsTaxExclusive ? (
                                    <>
                                      {getDetailData.taxes &&
                                      getDetailData.taxes.length > 0 &&
                                      getDetailData.taxes.filter(
                                        a =>
                                          a.itemIdentifyID == e.itemIdentifyID
                                      ).length > 0
                                        ? `+ ${getCurrData.currencyCode} ${
                                            getDetailData.taxes.filter(
                                              a =>
                                                a.itemIdentifyID ==
                                                e.itemIdentifyID
                                            )[0].baseTaxValue
                                          } Tax (${
                                            getDetailData.taxes.filter(
                                              a =>
                                                a.itemIdentifyID ==
                                                e.itemIdentifyID
                                            )[0].saleTaxName
                                          })`
                                        : 'No Tax'}
                                    </>
                                  ) : (
                                    <>
                                      {e.totalTax && e.totalTax > 0
                                        ? `incl ${
                                            getCurrData.currencyCode
                                          } ${formatDigits(
                                            parseFloatCustom(e.totalTax) /
                                              e.quantity,
                                            getDecimalPlaces
                                          )} Tax`
                                        : 'No Tax'}
                                    </>
                                  )}
                                  {/* + EUR 18.00 Tax (GST # 3) */}
                                </h4>
                              </Col>

                              <Col xl={8} lg={8} md={8} sm={8} xs={5}>
                                <h4 style={{ float: 'right' }}>
                                  {getIsTaxExclusive ? (
                                    <>
                                      {`${getCurrData.currencyCode} ${e.totalExcPrice}`}
                                    </>
                                  ) : (
                                    <>
                                      {`${getCurrData.currencyCode} ${e.totalIncPrice}`}
                                    </>
                                  )}
                                </h4>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )
                    })}

                  <Divider className='custom-promolist-divider' />

                  <Row className='mt-4'>
                    <Col span={8}>
                      <h4 className='mb-2'>
                        <IntlMessages id='sell.salehistory.note' />
                      </h4>
                      <h4 className='mb-2'>
                        {getDetailData.notes ? getDetailData.notes : ''}
                      </h4>
                      <div className='sub-txt-note'>
                        {getDetailData.key
                          ? ` (Ref No: ${getDecryptID(getDetailData.key)})`
                          : ''}
                        <br />
                        {getDetailData.isOffline && (
                          <>
                            <strong>{`Sale generated in OFFLINE Mode`}</strong>
                            <br />
                            <strong>{getDetailData.indexKey}</strong>
                          </>
                        )}
                      </div>
                    </Col>
                    <Col span={16}>
                      <Row>
                        <Col md={12} sm={12} xs={12} lg={16}>
                          <h4>
                            <IntlMessages id='sell.salehistory.subtotla' />
                          </h4>
                        </Col>

                        <Col md={12} sm={12} xs={12} lg={8}>
                          <h4 style={{ float: 'right' }}>
                            {getDetailData.totalPrice
                              ? `${getCurrData.currencyCode} ${formatDigits(
                                  customParse(getDetailData.totalPrice) +
                                    (getDetailData.salesOrderDiscountPrice &&
                                    getDetailData.salesOrderDiscountPrice !=
                                      '0.00'
                                      ? customParse(
                                          getDetailData.salesOrderDiscountPrice
                                        )
                                      : 0) -
                                    customParse(getDetailData.totalTax),
                                  getDecimalPlaces
                                )}`
                              : ''}
                          </h4>
                        </Col>
                      </Row>

                      {getDetailData.salesOrderDiscountPrice &&
                        getDetailData.salesOrderDiscountPrice != '0.00' && (
                          <Row>
                            <Col span={16}>
                              <h4>
                                <IntlMessages id='sell.salehistory.adddis' />
                              </h4>
                            </Col>

                            <Col span={8}>
                              <h4 style={{ float: 'right' }}>
                                {`${getDetailData.isRefundSale ? '' : '-'}${
                                  getCurrData.currencyCode
                                } ${
                                  getDetailData.salesOrderDiscountPrice &&
                                  getDetailData.salesOrderDiscountPrice.includes(
                                    '-'
                                  )
                                    ? getDetailData.salesOrderDiscountPrice.replace(
                                        '-',
                                        ''
                                      )
                                    : getDetailData.salesOrderDiscountPrice
                                }`}
                              </h4>
                            </Col>
                          </Row>
                        )}

                      <Row>
                        <Col span={16}>
                          <h4>
                            <IntlMessages id='sell.salehistory.totaltaxes' />
                          </h4>

                          <div style={{ marginLeft: 50 }}>
                            {getDetailData.taxesSum &&
                            getDetailData.taxesSum.length > 0 ? (
                              getDetailData.taxesSum.map((e, key) => {
                                return (
                                  <>
                                    <h5 key={key}>
                                      {(getDecryptID(
                                        getDetailData.sSalesOrderStatusID
                                      ) ==
                                        getDecryptID(
                                          fetchCurrentSalesOrder(
                                            'On Account, completed'
                                          )
                                        ) ||
                                        getDecryptID(
                                          getDetailData.sSalesOrderStatusID
                                        ) ==
                                          getDecryptID(
                                            fetchCurrentSalesOrder(
                                              'Layby, completed'
                                            )
                                          )) &&
                                      getDetailData.salesOrderDiscountPrice &&
                                      getDetailData.salesOrderDiscountPrice !=
                                        '0.00' ? (
                                        <>
                                          {e.saleTaxName
                                            ? `${e.saleTaxName} - (${e.taxValue}%)`
                                            : ''}
                                        </>
                                      ) : getDetailData.isRefundSale &&
                                        getDetailData.salesOrderDiscountPrice &&
                                        getDetailData.salesOrderDiscountPrice !=
                                          '0.00' ? (
                                        <>
                                          {e.saleTaxName
                                            ? `${e.saleTaxName} - (${e.taxValue}%)`
                                            : ''}
                                        </>
                                      ) : (
                                        <>
                                          {e.saleTaxName
                                            ? `${e.saleTaxName} - (${
                                                e.isFix ? e.fixRate : e.taxValue
                                              }
                                                ${
                                                  e.isFix ? ' FIX' : '%'
                                                })      ${
                                                getCurrData.currencyCode
                                              } ${e.taxPrice}`
                                            : ''}
                                        </>
                                      )}
                                    </h5>
                                  </>
                                )
                              })
                            ) : (
                              <h4>
                                <IntlMessages id='sell.salehistory.notax' />
                              </h4>
                            )}
                          </div>
                        </Col>

                        <Col span={8}>
                          <h4 style={{ float: 'right' }}>
                            {getDetailData.totalTax
                              ? `${getCurrData.currencyCode} ${getDetailData.totalTax}`
                              : ''}
                          </h4>
                        </Col>
                      </Row>

                      <Divider className='custom-promolist-divider' />

                      <Row>
                        <Col span={16}>
                          <h4>
                            <IntlMessages id='sell.salehistory.saletotal' />
                          </h4>
                        </Col>

                        <Col span={8}>
                          <h4
                            style={{ float: 'right' }}
                          >{`${getCurrData.currencyCode} ${getDetailData.totalPrice}`}</h4>
                        </Col>
                      </Row>

                      <Divider className='custom-promolist-divider' />

                      {getDetailData.payments &&
                        getDetailData.payments.length > 0 &&
                        getDetailData.payments.map((e, key) => {
                          return (
                            <Row key={key}>
                              <Col span={8}>
                                <h4>{e.paymentName ? e.paymentName : ''}</h4>
                              </Col>

                              <Col span={10}>
                                <p>
                                  {e.paymentOnDisplay ? e.paymentOnDisplay : ''}
                                </p>
                              </Col>

                              <Col span={6}>
                                <h4 style={{ float: 'right' }}>
                                  {e.amount
                                    ? `${getCurrData.currencyCode} ${e.amount}`
                                    : ''}
                                </h4>
                              </Col>
                            </Row>
                          )
                        })}

                      {getDetailData && getDetailData.change ? (
                        <Row>
                          <Col span={8}>
                            <h4>Change</h4>
                          </Col>

                          <Col span={10}>
                            {/* <h3>{e.paymentOnDisplay ? e.paymentOnDisplay : ""}</h3> */}
                          </Col>

                          <Col span={6}>
                            <h4 style={{ float: 'right' }}>
                              {`${getCurrData.currencyCode} ${getDetailData.change}`}
                            </h4>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}

                      {getDetailData.payments &&
                        getDetailData.payments.length > 0 && (
                          <Divider className='custom-promolist-divider' />
                        )}

                      <Row style={{ marginBottom: 12 }}>
                        <Col span={16}>
                          <h4>
                            <IntlMessages id='sell.salehistory.balance' />
                          </h4>
                        </Col>

                        <Col span={8}>
                          <h4 style={{ float: 'right' }}>
                            {getDetailData.balance
                              ? `${getCurrData.currencyCode} ${getDetailData.balance}`
                              : '0.00'}
                          </h4>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                  <div className='dk-expand-btn-mobile button-box'>
                    {getDetailData &&
                      getDetailData.sSalesOrderStatusID &&
                      getDetailData.sSalesOrderStatusID.includes('&') &&
                      (getDetailData.sSalesOrderStatusID.substring(
                        0,
                        getDetailData.sSalesOrderStatusID.indexOf('&')
                      ) == AllStatus.filter(a => a.id == 4)[0].id ||
                        getDetailData.sSalesOrderStatusID.substring(
                          0,
                          getDetailData.sSalesOrderStatusID.indexOf('&')
                        ) == AllStatus.filter(a => a.id == 5)[0].id) && (
                        <>
                          <Button
                            // className="custom-promolist-marksalebtn"
                            className='dk-btn-expand-mark-complete dk-wd-auto dk-hgt-50'
                            onClick={() => setVisibleModal(true)}
                            size='small'
                          >
                            <Space size='small'>
                              <CheckOutlined />
                              {<IntlMessages id='sell.salehistory.markcomp' />}
                            </Space>
                          </Button>
                        </>
                      )}

                    {getDetailData &&
                      getDetailData.sSalesOrderStatusID &&
                      getDetailData.sSalesOrderStatusID.includes('&') &&
                      getDecryptID(getDetailData.sSalesOrderStatusID) ==
                        getDecryptID(fetchCurrentSalesOrder('Completed')) && (
                        <>
                          {!getEditAllow ? (
                            <Tooltip
                              placement='leftBottom'
                              title={
                                <IntlMessages id='saleHistory.edit.notallow' />
                              }
                            >
                              <Button
                                className='custom-returnbtn disable-custom-btn'
                                icon={
                                  <EditOutlined className='dk-btn-icon-align' />
                                }
                              >
                                <IntlMessages id='products.promotionlisting.edit' />
                              </Button>
                            </Tooltip>
                          ) : (
                            <Button
                              className='edit-text-btn dk-btn-edit-expand dk-wd-auto dk-hgt-50'
                              onClick={() => onEditClick()}
                              disabled={
                                getDetailData.sSalesOrderStatusID &&
                                getDetailData.sSalesOrderStatusID.includes(
                                  '&'
                                ) &&
                                getDetailData.sSalesOrderStatusID.substring(
                                  0,
                                  getDetailData.sSalesOrderStatusID.indexOf('&')
                                ) == 11
                                  ? true
                                  : false
                              }
                              icon={
                                <EditOutlined className='dk-btn-icon-align' />
                              }
                            >
                              <IntlMessages id='products.promotionlisting.edit' />
                            </Button>
                          )}
                        </>
                      )}

                    <Button
                      className='email-text-btn dk-btn-expand-email-receipt dk-wd-auto dk-hgt-50'
                      onClick={() => dispatch(loadSendEmailModalShow(true))}
                      disabled={
                        getDetailData.sSalesOrderStatusID &&
                        getDetailData.sSalesOrderStatusID.includes('&') &&
                        getDecryptID(getDetailData.sSalesOrderStatusID) ==
                          getDecryptID(fetchCurrentSalesOrder('Voided'))
                      }
                      icon={<MailOutlined className='dk-btn-icon-align' />}
                    >
                      <IntlMessages id='sell.salehistory.emailrece' />
                    </Button>

                    {getDetailData.status &&
                      !getDetailData.status.includes('oided') && (
                        <InfoToPrint
                          data={getDetailData}
                          role='SaleListingPrint'
                          outletName={getOutletName}
                          registerName={getRegName}
                          allowPrintNote={getPrintNoteReceipt}
                          allowDiscountShow={getShowDiscounts}
                          showExtraPrinters={
                            !checkIsWeb().exist
                              ? localStorage.getItem('extraPrints') &&
                                localStorage.getItem('extraPrints') == '1'
                                ? true
                                : false
                              : false
                            // localStorage.getItem('extraPrints') &&
                            // localStorage.getItem('extraPrints') == '1'
                            //   ? true
                            //   : false
                          }
                        />
                      )}

                    {getDetailData.childs && getDetailData.childs.length > 0 ? (
                      <></>
                    ) : (
                      <>
                        {!getVoidAllow ? (
                          <Tooltip
                            placement='leftBottom'
                            title={
                              <IntlMessages id='saleHistory.void.notallow' />
                            }
                          >
                            <Button
                              className='custom-returnbtn disable-custom-btn'
                              icon={
                                <StopOutlined className='dk-btn-icon-align' />
                              }
                            >
                              <IntlMessages id='sell.salehistory.void' />
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button
                            className='dk-btn-expand-del dk-wd-auto dk-hgt-50'
                            onClick={() => showVoidConfirm(getDetailData.key)}
                            disabled={
                              getDetailData.sSalesOrderStatusID &&
                              getDetailData.sSalesOrderStatusID.includes('&') &&
                              getDetailData.sSalesOrderStatusID.substring(
                                0,
                                getDetailData.sSalesOrderStatusID.indexOf('&')
                              ) == 11
                                ? true
                                : false
                            }
                            icon={
                              <StopOutlined className='dk-btn-icon-align' />
                            }
                          >
                            <IntlMessages id='sell.salehistory.void' />
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Spin>
        )}
      </>
    )
  }

  const onFinish = values => {
    try {
      setIsSpinning(true)
      let payments = []
      if (getDetailData.payments && getDetailData.payments.length > 0) {
        getDetailData.payments.map((e, key) => {
          let payObj = {
            SalesOrderPaymentID: e.sSalesOrderPaymentID,
            PaymentTypeID: form.getFieldValue(`PaymentType${key}`)
              ? parseInt(form.getFieldValue(`PaymentType${key}`))
              : 0,
            PaymentDate: form.getFieldValue(`PaymentDateTime${key}`)
              ? form
                  .getFieldValue(`PaymentDateTime${key}`)
                  .format('DD/MM/YYYY hh:mm')
              : '',
            PaymentAmount: form.getFieldValue(`Amount${key}`)
              ? customParse(form.getFieldValue(`Amount${key}`))
              : ''
          }
          payments.push(payObj)
        })
      }
      let body = {
        SaleNote: values.Note,
        SaleDate: values.DateTime
          ? values.DateTime.format('DD/MM/YYYY hh:mm')
          : '',
        SalesOrderID: getDetailData.key,
        CustomerID:
          getReduxModalSearhedCus && getReduxModalSearhedCus.customerCode
            ? getReduxModalSearhedCus.key
            : '',
        IsCustomerRemove:
          getReduxModalSearhedCus && getReduxModalSearhedCus.customerCode
            ? false
            : true,
        Payments: payments
      }
      setVisible(false)
      postEditSale(body)
    } catch (ex) {
      message.warn('Error')
    }
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly Attend To Missing Field')
  }

  const onSearchFinish = values => {
    try {
      setTabLoader(true)
      let getRegID = ''
      let getOutletID = ''
      getRegID = values.Register === 'xxx' ? getRegID : values.Register
      if (getOutletDisabled) {
        const outID =
          getRegData.filter(
            a => getDecryptID(a.registerID) === getDecryptID(values.Register)
          ).length > 0
            ? getRegData.filter(
                a =>
                  getDecryptID(a.registerID) === getDecryptID(values.Register)
              )[0].outletID
            : ''
        getOutletID = outID
      } else {
        getOutletID = values.Outlet === 'xxx' ? getOutletID : values.Outlet
      }
      let bar_code_id = ''
      if (values.ReceiptNote && values.ReceiptNote.includes('_')) {
        bar_code_id = barCodeID(values.ReceiptNote)
      }
      let body = {
        StatusID: values.Status ? values.Status : 0,
        CustomerID:
          getReduxSearhedCus && getReduxSearhedCus.customerSId
            ? getReduxSearhedCus.customerSId
            : '',
        ReceiptOrNote:
          bar_code_id == '' && values.ReceiptNote ? values.ReceiptNote : '',
        OutletID: getOutletID
          ? `${getOutletID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
          : '',
        RegID: getRegID ? `${getRegID}&&_9efa-1ea9-4faf-88ed-a48e65b46643` : '',
        UserID: values.User ? values.User : '',
        FromSearchDate:
          values.Date && values.Date.length > 0
            ? values.Date[0].format('DD/MM/YYYY HH:mm')
            : '',
        ToSearchDate:
          values.Date && values.Date.length > 0
            ? values.Date[1].format('DD/MM/YYYY HH:mm')
            : '',
        CurrentPageNo: 1,
        PageSize: 10,
        // OrderID: values.OrderID ? values.OrderID : '',
        mode: parseInt(getCurrentTab),
        OrderID: bar_code_id != '' ? bar_code_id : '',
        isBarCode: bar_code_id != '' ? true : false
      }
      getFilteredSales(body)
      onRecepChange(values.ReceiptNote ? values.ReceiptNote : '')
    } catch (e) {
      setTabLoader(false)
      message.error('Problem, check connection...')
    }
  }

  const onSearchFinishFailed = errorInfo => {
    setIsSpinning(false)
    message.error('Kindly Attend to Missing Fields')
  }

  function onStatusSelect (val) {
    if (getCurrentTab == '1') {
      setAllStatus(val)
    } else if (getCurrentTab == '2') {
      setProcessRetStatus(val)
    } else if (getCurrentTab == '3') {
      setContSaleStatus(val)
    }
  }

  function onOutletSelect (val) {
    if (getCurrentTab == '1') {
      setAllOut(val)
    } else if (getCurrentTab == '2') {
      setProcessRetOut(val)
    } else if (getCurrentTab == '3') {
      setContSaleOut(val)
    }
  }

  function onUserSelect (val) {
    if (getCurrentTab == '1') {
      setAllUser(val)
    } else if (getCurrentTab == '2') {
      setProcessRetUser(val)
    } else if (getCurrentTab == '2') {
      setContSaleUser(val)
    }
  }

  function onRecepChange (val) {
    if (getCurrentTab == '1') {
      setAllRec(val)
    } else if (getCurrentTab == '2') {
      setProcessRetRec(val)
    } else if (getCurrentTab == '3') {
      setContSaleRec(val)
    }
  }

  function onCusChange (val) {
    //NOTE: move it to onSearchFinish as onRecepChange has done
    if (getCurrentTab == '1') {
      setAllCus(val.target.value)
    } else if (getCurrentTab == '2') {
      setProcessRetCus(val.target.value)
    } else if (getCurrentTab == '3') {
      setContSaleCus(val.target.value)
    }
  }

  function onDateChange (val) {
    if (getCurrentTab == '1') {
      setAllDate(val)
    } else if (getCurrentTab == '2') {
      setProcessRetDate(val)
    } else if (getCurrentTab == '3') {
      setContSaleDate(val)
    }
  }

  function onTabChange (key) {
    setTabLoader(true)
    const body = {
      OutletID:
        form.getFieldValue('Outlet') === 'xxx'
          ? ''
          : `${form.getFieldValue(
              'Outlet'
            )}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
      RegID:
        form.getFieldValue('Register') === 'xxx'
          ? ''
          : `${form.getFieldValue(
              'Register'
            )}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
      CurrentPageNo: 1,
      PageSize: 10,
      mode: parseInt(key)
    }
    getFilteredSales(body) // getListingService
    const out =
      form.getFieldValue('Outlet') === 'xxx'
        ? 'xxx'
        : form.getFieldValue('Outlet')
    const reg =
      form.getFieldValue('Register') === 'xxx'
        ? 'xxx'
        : form.getFieldValue('Register')
    if (key == 1) {
      setCurrentTab(key)
      setStatuses(AllStatus)
      form.setFieldsValue({
        Status: getAllStatus,
        Customer: getAllCus,
        ReceiptNote: getAllRec,
        Outlet: out, // 'xxx', // getAllOut,
        Register: reg, // 'xxx', // getAllReg,
        User: getAllUser,
        Date: getAllDate
      })
    } else if (key == 2) {
      setCurrentTab(key)
      setStatuses(ProcessReturnStatus)
      form.setFieldsValue({
        Status: getProcessRetStatus,
        Customer: getProcessRetCus,
        ReceiptNote: getProcessRetRec,
        Outlet: out, // 'xxx', // getAllOut,
        Register: reg, // 'xxx', // getAllReg,
        User: getProcessRetUser,
        Date: getProcessRetDate
      })
    } else if (key == 3) {
      setCurrentTab(key)
      setStatuses(ContinueSaleStatus)
      form.setFieldsValue({
        Status: getContSaleStatus,
        Customer: getContSaleCus,
        ReceiptNote: getContSaleRec,
        Outlet: out, // 'xxx', // getAllOut,
        Register: reg, // 'xxx', // getAllReg,
        User: getContSaleUser,
        Date: getContSaleDate
      })
    }
  }

  function onRegSelect (e) {
    if (e === 'xxx') {
      setOutletDisabled(false)
    } else {
      setOutletDisabled(true)
    }
  }

  function onOutSelect (e) {
    const data = getOutRegData
    const reg = []
    data.map(ee => {
      ee.registers &&
        ee.registers.length > 0 &&
        ee.registers.map(ff => {
          reg.push(ff)
        })
    })
    const regData =
      e === 'xxx'
        ? reg
        : reg.filter(xx => getDecryptID(xx.outletID) === getDecryptID(e))
    regData.splice(0, 0, { registerID: 'xxx', registerName: 'All Registers' })
    setRegData(regData && regData.length > 0 ? regData : [])

    if (getCurrentTab == '1') {
      setAllOut(e)
    } else if (getCurrentTab == '2') {
      setProcessRetOut(e)
    } else if (getCurrentTab == '3') {
      setContSaleOut(e)
    }
  }

  const FormFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} className=''>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`Status`}
          label={<IntlMessages id='sell.salehistory.col6' />}
        >
          <Select
            onSelect={onStatusSelect}
            size='large'
            showSearch={checkIsWeb().exist}
            optionFilterProp='children'
          >
            {getStatuses &&
              getStatuses.length > 0 &&
              getStatuses.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.value}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={'Register'}
          label={<IntlMessages id='sell.openclose.regdetail2' />}
        >
          <Select
            onSelect={onRegSelect}
            showSearch={checkIsWeb().exist}
            optionFilterProp='children'
          >
            {getRegData &&
              getRegData.length > 0 &&
              getRegData.map((e, key) => {
                return (
                  <Select.Option key={key} value={getDecryptID(e.registerID)}>
                    {e.registerName}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={'Outlet'}
          label={<IntlMessages id='sell.salehistory.out' />}
        >
          <Select
            onSelect={onOutSelect}
            disabled={getOutletDisabled}
            showSearch={checkIsWeb().exist}
            optionFilterProp='children'
          >
            {getOutRegData &&
              getOutRegData.length > 0 &&
              getOutRegData.map((e, key) => {
                return (
                  <Select.Option key={key} value={getDecryptID(e.outletID)}>
                    {e.outletName}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24} className='col-fix-full'>
        <SearchCustomer screen='SaleHistory' />
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          // className='ant-form-item-label-custom'
          name={`ReceiptNote`}
          label={<IntlMessages id='sell.salehistory.receiptnote' />}
        >
          <Input placeholder={'Receipt No / Note'} size='large' />
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`User`}
          label={<IntlMessages id='sell.salehistory.user' />}
        >
          <Select
            onSelect={onUserSelect}
            size='large'
            showSearch={checkIsWeb().exist}
            optionFilterProp='children'
          >
            {getReduxStoreUsers &&
              getReduxStoreUsers.length > 0 &&
              getReduxStoreUsers.map((e, key) => {
                let firstName = e.firstName ? e.firstName : ''
                let lastName = e.lastName ? e.lastName : ''
                let name = firstName + ' ' + lastName
                return (
                  <Select.Option key={key} value={e.id}>
                    {name}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,
      <Col lg={8} md={8} sm={12} xs={24}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`Date`}
          label={<IntlMessages id='sell.salehistory.date' />}
        >
          <RangePicker
            onChange={onDateChange}
            size='large'
            showTime={{ format: 'HH:mm' }}
            format='YYYY-MM-DD HH:mm'
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>
    )

    if (getExpand) {
      return children
    } else {
      return children.slice(0, 3)
    }
  }
  const handleClearFields = () => {
    form.resetFields()
    getFilteredSales({
      // getListingService
      CurrentPageNo: 1,
      PageSize: 10,
      showSizeChanger: true,
      mode: parseInt(getCurrentTab),
      OutletID:
        selOutletID && selOutletID != 'zz'
          ? `${selOutletID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
          : '',
      RegID:
        selRegID && selRegID != 'zz'
          ? `${selRegID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
          : ''
    })
  }
  const SearchFilters = () => {
    return (
      <Card className='Filters-wrapper Filters-border-with-tabs'>
        <Form
          form={form}
          name='SearchForm'
          className='ant-advanced-search-form Filters-Form'
          layout='horizontal'
          initialValues={{
            Outlet: selOutletID && selOutletID != 'zz' ? selOutletID : 'All',
            User: 'All',
            Status: parseInt(
              `${
                getCurrentTab == '1'
                  ? 10001
                  : getCurrentTab == '2'
                  ? 10002
                  : getCurrentTab == '3'
                  ? 1003
                  : ''
              }`
            ),
            Register: selRegID && selRegID != 'zz' ? selRegID : 'All'
          }}
          onFinish={onSearchFinish}
          onFinishFailed={onSearchFinishFailed}
        >
          <Row>{FormFields()}</Row>

          <div className='display-margin-unset'>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                <a
                  className='link-text dk-no-wrap mr-2'
                  onClick={() => {
                    setExpand(!getExpand)
                  }}
                >
                  <strong>
                    {getExpand ? (
                      <IntlMessages id='sell.salehistory.lessfil' />
                    ) : (
                      <IntlMessages id='sell.salehistory.morefil' />
                    )}
                  </strong>
                </a>

                <Button
                  type='primary'
                  className='clear-btn'
                  onClick={() => {
                    handleClearFields()
                  }}
                >
                  <IntlMessages id='sell.salehistory.clear' />
                </Button>

                <Button className='' type='primary' htmlType='submit'>
                  <IntlMessages id='sell.salehistory.search' />
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </Card>
    )
  }

  function onAccLaybyRetrve (id, indexKey) {
    // // NOTE: SINCE THIS SCREEN IS ONLY AVAILABLE WHEN SYSTEM IS ONLINE
    if (
      indexKey &&
      getDecryptID(getDetailData.sSalesOrderStatusID) ==
        getDecryptID(fetchCurrentSalesOrder('Parked'))
    ) {
      checkIfParkIndexed(indexKey, id)
    } else {
      getClickedSaleDetail(id)
    }
  }

  function checkIfParkIndexed (key, id) {
    dispatch(loadIsInProgress(true))
    setIsSpinning(true)
    dispatch(loadIsMainLoading(true))
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        if (e && e.length > 0) {
          let parkedSale = e.filter(q => q.indexKey == key)
          if (parkedSale && parkedSale.length > 0) {
            if (parkedSale[0].isOffline) {
              history.push('/dashboard/sell/mainsale/webregister')
              performMainSaleDetailAction(parkedSale)
            } else {
              getClickedSaleDetail(id)
            }
          }
        }
      })
      .catch(e => {
        getClickedSaleDetail(id)
        dispatch(loadIsMainLoading(false))
        setIsSpinning(false)
        console.log(
          'INDEX_DB_ERROR -> checkIfParkIndexed in sale history -->',
          e
        )
      })
  }

  function getClickedSaleDetail (id) {
    history.push('/dashboard/sell/mainsale/webregister')
    const body = {
      OutletID: '',
      SalesOrderID: id,
      SalesOrderStatusID: '',
      CustomerID: '',
      UserID: '',
      CurrentPageNo: 1,
      PageSize: 10
    }
    getMainSaleDetailService(body)
  }

  async function getMainSaleDetailService (body) {
    dispatch(loadIsInProgress(true))
    setIsSpinning(true)
    dispatch(loadIsMainLoading(true))
    const getSaleHistoryByIDas = ds.getSaleHistoryByIdService(
      body,
      BEHAVIOUR_TYPE.GET
    )
    await getSaleHistoryByIDas
      .then(data => {
        performMainSaleDetailAction(data)
      })
      .catch(e => {
        dispatch(loadIsMainLoading(false))
        setIsSpinning(false)
        notAllowMsgCheck(e)
      })
  }

  function performMainSaleDetailAction (data) {
    dispatch(loadIsMainLoading(false))
    setIsSpinning(false)
    if (data && data.length > 0) {
      let res = data[0]
      if (res && !isEmptyObject(res)) {
        //marking to identify that the prods coming first time from backend
        if (res.products && res.products.length > 0) {
          res.products.map(a => (a.firstTime = true))
        }
        if (
          res.products &&
          res.products.length > 0 &&
          (getDecryptID(res.sSalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
            getDecryptID(res.sSalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('On Account')))
        ) {
          res.products.map(a => (a.isOnAccount = true))
        }
        if (!isEmptyObject(getCurrentSalesOrderData)) {
          saleIsInProgress(dispatch, res)
        } else {
          //setting sell attributes
          let sellAttribs = []
          if (res.sellAttributes && res.sellAttributes.length > 0) {
            sellAttribs = res.sellAttributes
          }
          dispatch(loadSellSelectedAttributes(sellAttribs))
          if (res.isRefund) {
            loadIncomingSale(res, dispatch)
          } else {
            // for whole sale disc & note
            setDiscCurrPerNote(res, dispatch)
            // for customer
            if (res.customer && res.customer.length > 0) {
              let customer = res.customer[0]
              const firstLetter = customer.customerFirstName
                ? customer.customerFirstName.charAt(0)
                : 'x'
              const secondLetter = customer.customerLastName
                ? customer.customerLastName.charAt(0)
                : 'y'
              const lettersName =
                firstLetter.toUpperCase() + secondLetter.toUpperCase()
              customer.letterName = lettersName
              dispatch(loadCustomerSearchData(customer))
            }
            dispatch(loadPreventSellRunnerExecution(false))
            if (
              getDecryptID(res.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
              getDecryptID(res.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('On Account'))
            ) {
              let value = []
              value.push(res.totalPrice + res.totalTax)
              dispatch(loadAccLaybyCreditAmount(value))
            } else {
              dispatch(loadAccLaybyCreditAmount([]))
            }
            dispatch(loadCurrentSalesOrderData(res))
            localStorage.setItem('orderGuidID', res.key)
            dispatch(loadCurrentOrderGuidID(res.key))
          }
        }
      }
    }
  }

  function listUpdate () {
    let body = onSearchBody
    body.CurrentPageNo =
      getPagination && getPagination.CurrentPageNo
        ? getPagination.CurrentPageNo
        : 1
    body.PageSize =
      getPagination && getPagination.PageSize ? getPagination.PageSize : 10
    getFilteredSales(body)
  }

  const handleTableChange = (pagination, filters, sorter) => {
    if (getIsFiltered) {
      let body = onSearchBody
      body.CurrentPageNo = pagination.current
      body.PageSize = pagination.pageSize
      getFilteredSales(body)
    } else {
      let body = {
        CurrentPageNo: pagination.current,
        PageSize: pagination.pageSize,
        mode: parseInt(getCurrentTab)
      }
      getFilteredSales(body) // getListingService
    }
  }
  function handleScan (receiptiNo) {
    scanSearch(receiptiNo)
  }

  function handleError (receiptiNo) {
    scanSearch(receiptiNo)
  }

  const scanSearch = saleID => {
    let body = onSearchBody
    let rcpNo = saleID ? saleID : 0
    if (!StringIsNullOrEmpty(rcpNo)) {
      rcpNo = barCodeID(rcpNo)
      body.isBarCode = true
      body.OrderID = `${rcpNo}`
      getFilteredSales(body)
    }
  }

  function barCodeID (rcpNo) {
    let result = rcpNo
    if (rcpNo && rcpNo.includes('_')) {
      let aa = rcpNo.split('_')
      if (aa && aa.length > 3) {
        result = aa[3]
      }
    }
    return result
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper SalesHistory-pg'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getIsSpinning || outRegLoader}
        size='large'
      >
        {getOutletName && getRegName ? (
          <>
            {checkIsWeb().exist && (
              <Row>
                <Col span={24}>
                  <h1 className=''>
                    <IntlMessages id='sell.salehistory.help' />
                  </h1>
                </Col>
              </Row>
            )}

            <Card className='gx-card' title=''>
              <Collapse>
                <Panel
                  className='custom-promolist-help'
                  showArrow={false}
                  header={
                    <span>
                      <IntlMessages id='sell.salehistory.head' />
                    </span>
                  }
                >
                  <Row>
                    <div className='billing-main'>
                      <Col className='custom-promolist-helpdesc' span={12}>
                        <p>
                          <IntlMessages id='sell.salehistory.headhelp' />
                        </p>
                      </Col>

                      <Col span={12}>
                        <img src={SalesHistoryPic} alt='' />
                      </Col>
                    </div>
                  </Row>
                </Panel>
              </Collapse>
            </Card>

            <Tabs defaultActiveKey='1' size='large' onChange={onTabChange}>
              <TabPane
                tab={<IntlMessages id='sell.salehistory.tab1' />}
                key='1'
              >
                {SearchFilters()}
                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <>
                    <Table
                      className='gx-table-responsive custom-product-table font-weight-normal MinWidth-auto'
                      columns={colomns}
                      dataSource={getAllTableData}
                      expandable={{
                        // expandRowByClick: true,
                        expandedRowRender: (record, index) => (
                          <ExpandedRowRenderViewAll data={record} obj={index} />
                        ),
                        onExpand: (expanded, record) => {
                          if (expanded) {
                            setDetailLoading(true)
                            let body = {
                              SalesOrderID: record.key ? record.key : '',
                              OutID: record.sOutletID ? record.sOutletID : ''
                            }
                            getDetailService(body)
                            setAllEditModalData(record)
                            setSaleOrderID(record.key ? record.key : '')
                            setEmailAddress(record.customerEmail)
                          } else {
                            setSaleOrderID('')
                          }
                        }

                        // rowExpandable: (record) =>
                        //   record.key === "Not Expandable",
                      }}
                      expandRowByClick
                      rowKey={record => record.key}
                      expandedRowKeys={[getSaleOrderID]}
                      pagination={getPagination}
                      onChange={handleTableChange}
                      // pagination={false}
                      // footer={false}
                    />
                  </>
                )}
              </TabPane>
              <TabPane
                style={{ fontWeight: 'bold' }}
                tab={<IntlMessages id='sell.salehistory.tab2' />}
                key='2'
              >
                {SearchFilters()}

                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <>
                    {/* {getProcessReturnTableData &&
                      getProcessReturnTableData.length > 0 && (
                        <p style={{ marginBottom: 15, color: "#1890ff" }}>
                          <IntlMessages id="sell.salehistory.showinglast" />
                          {` ${getProcessReturnTableData.length} `}
                          <IntlMessages id="sell.salehistory.lastsales" />
                        </p>
                      )} */}
                    <Table
                      className='gx-table-responsive custom-product-table font-weight-normal MinWidth-auto'
                      columns={colomns}
                      dataSource={getProcessReturnTableData}
                      expandable={{
                        expandedRowRender: (record, index) => (
                          <ExpandedRowRenderViewAll data={record} obj={index} />
                        ),
                        onExpand: (expanded, record) => {
                          setDetailLoading(true)
                          let body = {
                            SalesOrderID: record.key ? record.key : '',
                            OutID: record.sOutletID ? record.sOutletID : ''
                          }
                          getDetailService(body)
                          setAllEditModalData(record)
                          setSaleOrderID(record.key ? record.key : '')
                          setEmailAddress(record.customerEmail)
                        }
                      }}
                      rowKey={record => record.key}
                      pagination={getPagination}
                      onChange={handleTableChange}
                      expandRowByClick
                      // pagination={false}
                      // footer={false}
                    />
                  </>
                )}
              </TabPane>
              <TabPane
                style={{ fontWeight: 'bold' }}
                tab={<IntlMessages id='sell.salehistory.tab3' />}
                key='3'
              >
                {SearchFilters()}

                {getTabLoader ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <>
                    <Table
                      className='gx-table-responsive custom-product-table font-weight-normal MinWidth-auto'
                      columns={colomns}
                      dataSource={getContSaleTableData}
                      expandable={{
                        expandedRowRender: (record, index) => (
                          <ExpandedRowRenderViewAll data={record} obj={index} />
                        ),
                        onExpand: (expanded, record) => {
                          setDetailLoading(true)
                          let body = {
                            SalesOrderID: record.key ? record.key : '',
                            OutID: record.sOutletID ? record.sOutletID : ''
                          }
                          getDetailService(body)
                          setAllEditModalData(record)
                          setSaleOrderID(record.key ? record.key : '')
                          setEmailAddress(record.customerEmail)
                        }
                      }}
                      expandRowByClick
                      rowKey={record => record.key}
                      pagination={getPagination}
                      onChange={handleTableChange}
                    />
                  </>
                )}
              </TabPane>
            </Tabs>
          </>
        ) : (
          <>
            <Row justify='center'>
              <Col>
                <h1>Kindly Select Register and Outlet</h1>
              </Col>
            </Row>
          </>
        )}
      </Spin>

      <Modal
        className='Salehistory-Modal'
        title={
          <span>
            <IntlMessages id='sell.salehistory.salerec' />{' '}
            {getAllEditModalData.receiptCode
              ? getAllEditModalData.receiptCode
              : ''}
          </span>
        }
        centered
        visible={visible}
        width={850}
        footer={
          <>
            <Form
              form={form}
              name='EditSaleForm'
              scrollToFirstError
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Button
                className='dk-btn-cancel'
                type='primary'
                onClick={() => setVisible(false)}
              >
                <IntlMessages id='products.addpricebook.cancel' />
              </Button>

              <Button
                className='custom-searchbtn'
                htmlType='submit'
                type='primary'
              >
                <IntlMessages id='products.promoadd.rewardsave' />
              </Button>
            </Form>
          </>
        }
        onCancel={() => setVisible(false)}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <p>
              <IntlMessages id='sell.salehistory.modaldesxc' />
            </p>
          </Col>
        </Row>

        <div className='mt-2'>
          <Form
            name='EditSaleForm'
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Row>
              <Col lg={12} md={12} sm={24} xs={24} className='pl-0-device'>
                <Form.Item
                  name='DateTime'
                  className='Pro-Note'
                  label={<IntlMessages id='sell.salehistory.saledate' />}
                  required
                >
                  <DatePicker
                    className='w-100'
                    format='YYYY-MM-DD HH:mm:ss'
                    showTime={{
                      defaultValue: moment('00:00:00', 'HH:mm:ss')
                    }}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </Col>

              <Col lg={12} md={12} sm={24} xs={24} className='pr-0-device'>
                <label className='mb-0'>
                  <IntlMessages id='customer.addCustomer.title' />
                </label>
                <Row>
                  {getReduxModalSearhedCus &&
                  getReduxModalSearhedCus.customerCode ? (
                    <>
                      <Col
                        lg={22}
                        md={22}
                        sm={22}
                        xs={22}
                        className='pl-0-device'
                      >
                        <div className='gx-module-list-icon'>
                          <Row gutter={12}>
                            <Col>
                              <div className='gx'>
                                <Avatar
                                  style={{ fontWeight: 'bold' }}
                                  className={`gx-avatar gx-bg-${
                                    true == 'even' ? 'green' : 'blue'
                                  } gx-size-46 mr-10`}
                                >
                                  {getReduxModalSearhedCus.letterName
                                    ? getReduxModalSearhedCus.letterName
                                    : '00'}
                                </Avatar>
                              </div>
                            </Col>

                            <Col>
                              <div className='gx-module-list-content'>
                                <div className='gx-mail-user-des'>
                                  <span className='gx-sender-name'>
                                    {getReduxModalSearhedCus.customerName
                                      ? getReduxModalSearhedCus.customerName
                                      : '-NAME-'}
                                  </span>

                                  <span className='gx-toolbar-separator'>
                                    &nbsp;
                                  </span>

                                  <span className='vd-flag sm:hidden'>
                                    {getReduxModalSearhedCus.groupName
                                      ? getReduxModalSearhedCus.groupName
                                      : 'All Customers'}
                                  </span>
                                </div>
                                <div className='gx-message'>
                                  <p className='gx-text-truncate'>
                                    {getReduxModalSearhedCus.customerCode
                                      ? getReduxModalSearhedCus.customerCode
                                      : '000-ABC'}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col lg={2} md={2} sm={2} xs={2} className='p-0'>
                        <div className='del-btn-div'>
                          <a
                            onClick={() =>
                              dispatch(loadHistoryModalCusSearch({}))
                            }
                            className='trash-icon-btn'
                          >
                            <i className='icon icon-trash' />
                          </a>
                        </div>
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col lg={24} md={24} sm={24} xs={24} className='p-0'>
                        <Form
                          name='EditSaleForm'
                          form={form}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          scrollToFirstError
                        >
                          <SearchCustomer screen='HistoryModal' />
                        </Form>
                      </Col>
                    </>
                  )}
                </Row>
              </Col>

              <Col lg={24} md={24} sm={24} xs={24} className='p-0 mt-2'>
                <Form
                  name='EditSaleForm'
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  scrollToFirstError
                  layout='vertical'
                >
                  <Form.Item
                    name='Note'
                    label={
                      <span>
                        <IntlMessages id='sell.salehistory.note' />
                      </span>
                    }
                    help={<IntlMessages id='sell.salehistory.maxnote' />}
                  >
                    <Input.TextArea
                      placeholder='Enter a note for this sale.'
                      rows={5}
                      maxLength={2000}
                    />
                  </Form.Item>
                </Form>
              </Col>

              <Col lg={24} md={24} sm={24} xs={24} className='p-0 mt-2'>
                {editPayList &&
                  editPayList.length > 0 &&
                  editPayList.map((e, key) => {
                    return (
                      <Row key={key} className='mb-3'>
                        <Col
                          lg={8}
                          md={8}
                          sm={24}
                          xs={24}
                          className='pl-0-device'
                        >
                          <Form
                            name='EditSaleForm'
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            scrollToFirstError
                          >
                            <Form.Item
                              name={`PaymentType${key}`}
                              className='Pro-Note'
                              label={
                                <span>
                                  <IntlMessages id='sell.salehistory.paymenttype' />
                                </span>
                              }
                            >
                              <Select
                                placeholder={
                                  // <IntlMessages id="sell.salehistory.addcus" />
                                  'Payment Type'
                                }
                                className='w-100'
                              >
                                {getPaymentList &&
                                  getPaymentList.length > 0 &&
                                  getPaymentList.map((e, key) => {
                                    return (
                                      <Select.Option
                                        value={e.paymentTypeId}
                                        key={e.paymentTypeId}
                                      >
                                        {e.paymentTypeName}
                                      </Select.Option>
                                    )
                                  })}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col lg={8} md={8} sm={24} xs={24} className='md-pad-0'>
                          <Form
                            name='EditSaleForm'
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            scrollToFirstError
                          >
                            <Form.Item
                              name={`PaymentDateTime${key}`}
                              className='Pro-Note'
                              label={
                                <span>
                                  <IntlMessages id='sell.salehistory.paydate' />
                                </span>
                              }
                            >
                              <DatePicker
                                style={{ width: '100%' }}
                                format='YYYY-MM-DD HH:mm:ss'
                                showTime={{
                                  defaultValue: moment('00:00:00', 'HH:mm:ss')
                                }}
                                inputReadOnly={true}
                              />
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col
                          lg={8}
                          md={8}
                          sm={24}
                          xs={24}
                          className='pr-0-device'
                        >
                          <Form
                            name='EditSaleForm'
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            scrollToFirstError
                          >
                            <Form.Item
                              name={`Amount${key}`}
                              className='Pro-Note'
                              label={
                                <span>
                                  <IntlMessages id='sell.salehistory.amount' />
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id='sell.salehistory.enteramount' />
                                  )
                                }
                              ]}
                            >
                              <InputNumber
                                type='number'
                                className='w-100'
                                min={0.1}
                                step={0.1}
                                max={100000000}
                                // defaultValue={0.0}
                              />
                            </Form.Item>
                          </Form>
                        </Col>
                      </Row>
                    )
                  })}
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <CustomerModal
        id={getModalCusID}
        currShort={getCurrData.currencyCode ? getCurrData.currencyCode : ''}
      />
      <BarcodeReader
        onError={e => {
          handleError(e)
        }}
        onScan={e => {
          handleScan(e)
        }}
      />
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default HistoryListing
